import { m as makeForwardRef, _ as _extends } from './common-2912ca79.esm.js';
import * as React from 'react';
import { f as forwardRef$1 } from './hover-1a096548.esm.js';

var forwardRef = /*#__PURE__*/makeForwardRef('feather');

var SvgComponent$5o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-activity",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "22 12 18 12 15 21 9 3 6 12 2 12"
  }));
};
var ForwardRef$5o = /*#__PURE__*/forwardRef(SvgComponent$5o, 'activity', false);

var SvgComponent$5n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-airplay",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12 15 17 21 7 21 12 15"
  }));
};
var ForwardRef$5n = /*#__PURE__*/forwardRef(SvgComponent$5n, 'airplay', false);

var SvgComponent$5m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
};
var ForwardRef$5m = /*#__PURE__*/forwardRef(SvgComponent$5m, 'alert-circle', false);

var SvgComponent$5l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-octagon",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12.01,
    y2: 16
  }));
};
var ForwardRef$5l = /*#__PURE__*/forwardRef(SvgComponent$5l, 'alert-octagon', false);

var SvgComponent$5k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-alert-triangle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12.01,
    y2: 17
  }));
};
var ForwardRef$5k = /*#__PURE__*/forwardRef(SvgComponent$5k, 'alert-triangle', false);

var SvgComponent$5j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-align-center",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10,
    x2: 6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 18,
    x2: 6,
    y2: 18
  }));
};
var ForwardRef$5j = /*#__PURE__*/forwardRef(SvgComponent$5j, 'align-center', false);

var SvgComponent$5i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-align-justify",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 3,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 3,
    y2: 18
  }));
};
var ForwardRef$5i = /*#__PURE__*/forwardRef(SvgComponent$5i, 'align-justify', false);

var SvgComponent$5h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-align-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 10,
    x2: 3,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 18,
    x2: 3,
    y2: 18
  }));
};
var ForwardRef$5h = /*#__PURE__*/forwardRef(SvgComponent$5h, 'align-left', false);

var SvgComponent$5g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-align-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 10,
    x2: 7,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 6,
    x2: 3,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 14,
    x2: 3,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 7,
    y2: 18
  }));
};
var ForwardRef$5g = /*#__PURE__*/forwardRef(SvgComponent$5g, 'align-right', false);

var SvgComponent$5f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-anchor",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12H2a10 10 0 0 0 20 0h-3"
  }));
};
var ForwardRef$5f = /*#__PURE__*/forwardRef(SvgComponent$5f, 'anchor', false);

var SvgComponent$5e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-aperture",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 8,
    x2: 20.05,
    y2: 17.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 8,
    x2: 21.17,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.38,
    y1: 12,
    x2: 13.12,
    y2: 2.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.69,
    y1: 16,
    x2: 3.95,
    y2: 6.06
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.31,
    y1: 16,
    x2: 2.83,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.62,
    y1: 12,
    x2: 10.88,
    y2: 21.94
  }));
};
var ForwardRef$5e = /*#__PURE__*/forwardRef(SvgComponent$5e, 'aperture', false);

var SvgComponent$5d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-archive",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "21 8 21 21 3 21 3 8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 22,
    height: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 14,
    y2: 12
  }));
};
var ForwardRef$5d = /*#__PURE__*/forwardRef(SvgComponent$5d, 'archive', false);

var SvgComponent$5c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-down-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 12 12 16 16 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }));
};
var ForwardRef$5c = /*#__PURE__*/forwardRef(SvgComponent$5c, 'arrow-down-circle', false);

var SvgComponent$5b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-down-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 17 7 17 7 7"
  }));
};
var ForwardRef$5b = /*#__PURE__*/forwardRef(SvgComponent$5b, 'arrow-down-left', false);

var SvgComponent$5a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-down-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 17,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 7 17 17 7 17"
  }));
};
var ForwardRef$5a = /*#__PURE__*/forwardRef(SvgComponent$5a, 'arrow-down-right', false);

var SvgComponent$59 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 12 12 19 5 12"
  }));
};
var ForwardRef$59 = /*#__PURE__*/forwardRef(SvgComponent$59, 'arrow-down', false);

var SvgComponent$58 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-left-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 8 8 12 12 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 8,
    y2: 12
  }));
};
var ForwardRef$58 = /*#__PURE__*/forwardRef(SvgComponent$58, 'arrow-left-circle', false);

var SvgComponent$57 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 5,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 19 5 12 12 5"
  }));
};
var ForwardRef$57 = /*#__PURE__*/forwardRef(SvgComponent$57, 'arrow-left', false);

var SvgComponent$56 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-right-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 16 16 12 12 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$56 = /*#__PURE__*/forwardRef(SvgComponent$56, 'arrow-right-circle', false);

var SvgComponent$55 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 5 19 12 12 19"
  }));
};
var ForwardRef$55 = /*#__PURE__*/forwardRef(SvgComponent$55, 'arrow-right', false);

var SvgComponent$54 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-up-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 12 12 8 8 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 8
  }));
};
var ForwardRef$54 = /*#__PURE__*/forwardRef(SvgComponent$54, 'arrow-up-circle', false);

var SvgComponent$53 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-up-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 17 7 7 17 7"
  }));
};
var ForwardRef$53 = /*#__PURE__*/forwardRef(SvgComponent$53, 'arrow-up-left', false);

var SvgComponent$52 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-up-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 17,
    x2: 17,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 7 17 7 17 17"
  }));
};
var ForwardRef$52 = /*#__PURE__*/forwardRef(SvgComponent$52, 'arrow-up-right', false);

var SvgComponent$51 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-arrow-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "5 12 12 5 19 12"
  }));
};
var ForwardRef$51 = /*#__PURE__*/forwardRef(SvgComponent$51, 'arrow-up', false);

var SvgComponent$50 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-at-sign",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"
  }));
};
var ForwardRef$50 = /*#__PURE__*/forwardRef(SvgComponent$50, 'at-sign', false);

var SvgComponent$4$ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-award",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.21 13.89 7 23 12 20 17 23 15.79 13.88"
  }));
};
var ForwardRef$4$ = /*#__PURE__*/forwardRef(SvgComponent$4$, 'award', false);

var SvgComponent$4_ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bar-chart-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 14
  }));
};
var ForwardRef$4_ = /*#__PURE__*/forwardRef(SvgComponent$4_, 'bar-chart-2', false);

var SvgComponent$4Z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bar-chart",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 20,
    x2: 18,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 20,
    x2: 6,
    y2: 16
  }));
};
var ForwardRef$4Z = /*#__PURE__*/forwardRef(SvgComponent$4Z, 'bar-chart', false);

var SvgComponent$4Y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-battery-charging",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 13,
    x2: 23,
    y2: 11
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "11 6 7 12 13 12 9 18"
  }));
};
var ForwardRef$4Y = /*#__PURE__*/forwardRef(SvgComponent$4Y, 'battery-charging', false);

var SvgComponent$4X = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-battery",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 18,
    height: 12,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 13,
    x2: 23,
    y2: 11
  }));
};
var ForwardRef$4X = /*#__PURE__*/forwardRef(SvgComponent$4X, 'battery', false);

var SvgComponent$4W = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bell-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21a2 2 0 0 1-3.46 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.63 13A17.89 17.89 0 0 1 18 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8a6 6 0 0 0-9.33-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$4W = /*#__PURE__*/forwardRef(SvgComponent$4W, 'bell-off', false);

var SvgComponent$4V = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bell",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.73 21a2 2 0 0 1-3.46 0"
  }));
};
var ForwardRef$4V = /*#__PURE__*/forwardRef(SvgComponent$4V, 'bell', false);

var SvgComponent$4U = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bluetooth",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"
  }));
};
var ForwardRef$4U = /*#__PURE__*/forwardRef(SvgComponent$4U, 'bluetooth', false);

var SvgComponent$4T = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bold",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
  }));
};
var ForwardRef$4T = /*#__PURE__*/forwardRef(SvgComponent$4T, 'bold', false);

var SvgComponent$4S = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-book-open",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"
  }));
};
var ForwardRef$4S = /*#__PURE__*/forwardRef(SvgComponent$4S, 'book-open', false);

var SvgComponent$4R = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-book",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
  }));
};
var ForwardRef$4R = /*#__PURE__*/forwardRef(SvgComponent$4R, 'book', false);

var SvgComponent$4Q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-bookmark",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  }));
};
var ForwardRef$4Q = /*#__PURE__*/forwardRef(SvgComponent$4Q, 'bookmark', false);

var SvgComponent$4P = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-box",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3.27 6.96 12 12.01 20.73 6.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22.08,
    x2: 12,
    y2: 12
  }));
};
var ForwardRef$4P = /*#__PURE__*/forwardRef(SvgComponent$4P, 'box', false);

var SvgComponent$4O = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-briefcase",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 14,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
  }));
};
var ForwardRef$4O = /*#__PURE__*/forwardRef(SvgComponent$4O, 'briefcase', false);

var SvgComponent$4N = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-calendar",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 2,
    x2: 16,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10
  }));
};
var ForwardRef$4N = /*#__PURE__*/forwardRef(SvgComponent$4N, 'calendar', false);

var SvgComponent$4M = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-camera-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"
  }));
};
var ForwardRef$4M = /*#__PURE__*/forwardRef(SvgComponent$4M, 'camera-off', false);

var SvgComponent$4L = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-camera",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 4
  }));
};
var ForwardRef$4L = /*#__PURE__*/forwardRef(SvgComponent$4L, 'camera', false);

var SvgComponent$4K = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cast",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 20,
    x2: 2.01,
    y2: 20
  }));
};
var ForwardRef$4K = /*#__PURE__*/forwardRef(SvgComponent$4K, 'cast', false);

var SvgComponent$4J = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22 4 12 14.01 9 11.01"
  }));
};
var ForwardRef$4J = /*#__PURE__*/forwardRef(SvgComponent$4J, 'check-circle', false);

var SvgComponent$4I = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "9 11 12 14 22 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
  }));
};
var ForwardRef$4I = /*#__PURE__*/forwardRef(SvgComponent$4I, 'check-square', false);

var SvgComponent$4H = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
};
var ForwardRef$4H = /*#__PURE__*/forwardRef(SvgComponent$4H, 'check', false);

var SvgComponent$4G = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  }));
};
var ForwardRef$4G = /*#__PURE__*/forwardRef(SvgComponent$4G, 'chevron-down', false);

var SvgComponent$4F = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "15 18 9 12 15 6"
  }));
};
var ForwardRef$4F = /*#__PURE__*/forwardRef(SvgComponent$4F, 'chevron-left', false);

var SvgComponent$4E = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "9 18 15 12 9 6"
  }));
};
var ForwardRef$4E = /*#__PURE__*/forwardRef(SvgComponent$4E, 'chevron-right', false);

var SvgComponent$4D = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "18 15 12 9 6 15"
  }));
};
var ForwardRef$4D = /*#__PURE__*/forwardRef(SvgComponent$4D, 'chevron-up', false);

var SvgComponent$4C = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "7 13 12 18 17 13"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 6 12 11 17 6"
  }));
};
var ForwardRef$4C = /*#__PURE__*/forwardRef(SvgComponent$4C, 'chevrons-down', false);

var SvgComponent$4B = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "11 17 6 12 11 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18 17 13 12 18 7"
  }));
};
var ForwardRef$4B = /*#__PURE__*/forwardRef(SvgComponent$4B, 'chevrons-left', false);

var SvgComponent$4A = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "13 17 18 12 13 7"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6 17 11 12 6 7"
  }));
};
var ForwardRef$4A = /*#__PURE__*/forwardRef(SvgComponent$4A, 'chevrons-right', false);

var SvgComponent$4z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevrons-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "17 11 12 6 7 11"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 18 12 13 7 18"
  }));
};
var ForwardRef$4z = /*#__PURE__*/forwardRef(SvgComponent$4z, 'chevrons-up', false);

var SvgComponent$4y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chrome",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.17,
    y1: 8,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.95,
    y1: 6.06,
    x2: 8.54,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.88,
    y1: 21.94,
    x2: 15.46,
    y2: 14
  }));
};
var ForwardRef$4y = /*#__PURE__*/forwardRef(SvgComponent$4y, 'chrome', false);

var SvgComponent$4x = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }));
};
var ForwardRef$4x = /*#__PURE__*/forwardRef(SvgComponent$4x, 'circle', false);

var SvgComponent$4w = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-clipboard",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 8,
    height: 4,
    rx: 1,
    ry: 1
  }));
};
var ForwardRef$4w = /*#__PURE__*/forwardRef(SvgComponent$4w, 'clipboard', false);

var SvgComponent$4v = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-clock",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 6 12 12 16 14"
  }));
};
var ForwardRef$4v = /*#__PURE__*/forwardRef(SvgComponent$4v, 'clock', false);

var SvgComponent$4u = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-drizzle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 19,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 19,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  }));
};
var ForwardRef$4u = /*#__PURE__*/forwardRef(SvgComponent$4u, 'cloud-drizzle', false);

var SvgComponent$4t = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-lightning",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 11 9 17 15 17 11 23"
  }));
};
var ForwardRef$4t = /*#__PURE__*/forwardRef(SvgComponent$4t, 'cloud-lightning', false);

var SvgComponent$4s = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$4s = /*#__PURE__*/forwardRef(SvgComponent$4s, 'cloud-off', false);

var SvgComponent$4r = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-rain",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 13,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"
  }));
};
var ForwardRef$4r = /*#__PURE__*/forwardRef(SvgComponent$4r, 'cloud-rain', false);

var SvgComponent$4q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud-snow",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 16,
    x2: 8.01,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 20,
    x2: 8.01,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12.01,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16,
    x2: 16.01,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 20,
    x2: 16.01,
    y2: 20
  }));
};
var ForwardRef$4q = /*#__PURE__*/forwardRef(SvgComponent$4q, 'cloud-snow', false);

var SvgComponent$4p = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cloud",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"
  }));
};
var ForwardRef$4p = /*#__PURE__*/forwardRef(SvgComponent$4p, 'cloud', false);

var SvgComponent$4o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-code",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 18 22 12 16 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 6 2 12 8 18"
  }));
};
var ForwardRef$4o = /*#__PURE__*/forwardRef(SvgComponent$4o, 'code', false);

var SvgComponent$4n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-codepen",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22 8.5 12 15.5 2 8.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 15.5 12 8.5 22 15.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 8.5
  }));
};
var ForwardRef$4n = /*#__PURE__*/forwardRef(SvgComponent$4n, 'codepen', false);

var SvgComponent$4m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-codesandbox",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.5 4.21 12 6.81 16.5 4.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.5 19.79 7.5 14.6 3 12"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 12 16.5 14.6 16.5 19.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3.27 6.96 12 12.01 20.73 6.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22.08,
    x2: 12,
    y2: 12
  }));
};
var ForwardRef$4m = /*#__PURE__*/forwardRef(SvgComponent$4m, 'codesandbox', false);

var SvgComponent$4l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-coffee",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 8h1a4 4 0 0 1 0 8h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 1,
    x2: 6,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 1,
    x2: 14,
    y2: 4
  }));
};
var ForwardRef$4l = /*#__PURE__*/forwardRef(SvgComponent$4l, 'coffee', false);

var SvgComponent$4k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-columns",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"
  }));
};
var ForwardRef$4k = /*#__PURE__*/forwardRef(SvgComponent$4k, 'columns', false);

var SvgComponent$4j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-command",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
  }));
};
var ForwardRef$4j = /*#__PURE__*/forwardRef(SvgComponent$4j, 'command', false);

var SvgComponent$4i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-compass",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"
  }));
};
var ForwardRef$4i = /*#__PURE__*/forwardRef(SvgComponent$4i, 'compass', false);

var SvgComponent$4h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-copy",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 13,
    height: 13,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  }));
};
var ForwardRef$4h = /*#__PURE__*/forwardRef(SvgComponent$4h, 'copy', false);

var SvgComponent$4g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-down-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "9 10 4 15 9 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a4 4 0 0 1-4 4H4"
  }));
};
var ForwardRef$4g = /*#__PURE__*/forwardRef(SvgComponent$4g, 'corner-down-left', false);

var SvgComponent$4f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-down-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "15 10 20 15 15 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4v7a4 4 0 0 0 4 4h12"
  }));
};
var ForwardRef$4f = /*#__PURE__*/forwardRef(SvgComponent$4f, 'corner-down-right', false);

var SvgComponent$4e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-left-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "14 15 9 20 4 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-7a4 4 0 0 0-4 4v12"
  }));
};
var ForwardRef$4e = /*#__PURE__*/forwardRef(SvgComponent$4e, 'corner-left-down', false);

var SvgComponent$4d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-left-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "14 9 9 4 4 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20h-7a4 4 0 0 1-4-4V4"
  }));
};
var ForwardRef$4d = /*#__PURE__*/forwardRef(SvgComponent$4d, 'corner-left-up', false);

var SvgComponent$4c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-right-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "10 15 15 20 20 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h7a4 4 0 0 1 4 4v12"
  }));
};
var ForwardRef$4c = /*#__PURE__*/forwardRef(SvgComponent$4c, 'corner-right-down', false);

var SvgComponent$4b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-right-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "10 9 15 4 20 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20h7a4 4 0 0 0 4-4V4"
  }));
};
var ForwardRef$4b = /*#__PURE__*/forwardRef(SvgComponent$4b, 'corner-right-up', false);

var SvgComponent$4a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-up-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "9 14 4 9 9 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v-7a4 4 0 0 0-4-4H4"
  }));
};
var ForwardRef$4a = /*#__PURE__*/forwardRef(SvgComponent$4a, 'corner-up-left', false);

var SvgComponent$49 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-corner-up-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "15 14 20 9 15 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-7a4 4 0 0 1 4-4h12"
  }));
};
var ForwardRef$49 = /*#__PURE__*/forwardRef(SvgComponent$49, 'corner-up-right', false);

var SvgComponent$48 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-cpu",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 1,
    x2: 9,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 1,
    x2: 15,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 9,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 20,
    x2: 15,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 9,
    x2: 23,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 14,
    x2: 23,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 9,
    x2: 4,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14,
    x2: 4,
    y2: 14
  }));
};
var ForwardRef$48 = /*#__PURE__*/forwardRef(SvgComponent$48, 'cpu', false);

var SvgComponent$47 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-credit-card",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 10,
    x2: 23,
    y2: 10
  }));
};
var ForwardRef$47 = /*#__PURE__*/forwardRef(SvgComponent$47, 'credit-card', false);

var SvgComponent$46 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-crop",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.13 1L6 16a2 2 0 0 0 2 2h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 6.13L16 6a2 2 0 0 1 2 2v15"
  }));
};
var ForwardRef$46 = /*#__PURE__*/forwardRef(SvgComponent$46, 'crop', false);

var SvgComponent$45 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-crosshair",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 12,
    x2: 18,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 12,
    x2: 2,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 18
  }));
};
var ForwardRef$45 = /*#__PURE__*/forwardRef(SvgComponent$45, 'crosshair', false);

var SvgComponent$44 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-database",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 9,
    ry: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"
  }));
};
var ForwardRef$44 = /*#__PURE__*/forwardRef(SvgComponent$44, 'database', false);

var SvgComponent$43 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-delete",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 9,
    x2: 12,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 18,
    y2: 15
  }));
};
var ForwardRef$43 = /*#__PURE__*/forwardRef(SvgComponent$43, 'delete', false);

var SvgComponent$42 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-disc",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
};
var ForwardRef$42 = /*#__PURE__*/forwardRef(SvgComponent$42, 'disc', false);

var SvgComponent$41 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-divide-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }));
};
var ForwardRef$41 = /*#__PURE__*/forwardRef(SvgComponent$41, 'divide-circle', false);

var SvgComponent$40 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-divide-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 8
  }));
};
var ForwardRef$40 = /*#__PURE__*/forwardRef(SvgComponent$40, 'divide-square', false);

var SvgComponent$3$ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-divide",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 2
  }));
};
var ForwardRef$3$ = /*#__PURE__*/forwardRef(SvgComponent$3$, 'divide', false);

var SvgComponent$3_ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-dollar-sign",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
  }));
};
var ForwardRef$3_ = /*#__PURE__*/forwardRef(SvgComponent$3_, 'dollar-sign', false);

var SvgComponent$3Z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-download-cloud",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "8 17 12 21 16 17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"
  }));
};
var ForwardRef$3Z = /*#__PURE__*/forwardRef(SvgComponent$3Z, 'download-cloud', false);

var SvgComponent$3Y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-download",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 15,
    x2: 12,
    y2: 3
  }));
};
var ForwardRef$3Y = /*#__PURE__*/forwardRef(SvgComponent$3Y, 'download', false);

var SvgComponent$3X = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-dribbble",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"
  }));
};
var ForwardRef$3X = /*#__PURE__*/forwardRef(SvgComponent$3X, 'dribbble', false);

var SvgComponent$3W = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-droplet",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"
  }));
};
var ForwardRef$3W = /*#__PURE__*/forwardRef(SvgComponent$3W, 'droplet', false);

var SvgComponent$3V = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-edit-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
  }));
};
var ForwardRef$3V = /*#__PURE__*/forwardRef(SvgComponent$3V, 'edit-2', false);

var SvgComponent$3U = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-edit-3",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 20h9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
  }));
};
var ForwardRef$3U = /*#__PURE__*/forwardRef(SvgComponent$3U, 'edit-3', false);

var SvgComponent$3T = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-edit",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  }));
};
var ForwardRef$3T = /*#__PURE__*/forwardRef(SvgComponent$3T, 'edit', false);

var SvgComponent$3S = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-external-link",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 14,
    x2: 21,
    y2: 3
  }));
};
var ForwardRef$3S = /*#__PURE__*/forwardRef(SvgComponent$3S, 'external-link', false);

var SvgComponent$3R = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-eye-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$3R = /*#__PURE__*/forwardRef(SvgComponent$3R, 'eye-off', false);

var SvgComponent$3Q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-eye",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }));
};
var ForwardRef$3Q = /*#__PURE__*/forwardRef(SvgComponent$3Q, 'eye', false);

var SvgComponent$3P = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-facebook",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
  }));
};
var ForwardRef$3P = /*#__PURE__*/forwardRef(SvgComponent$3P, 'facebook', false);

var SvgComponent$3O = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-fast-forward",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "13 19 22 12 13 5 13 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2 19 11 12 2 5 2 19"
  }));
};
var ForwardRef$3O = /*#__PURE__*/forwardRef(SvgComponent$3O, 'fast-forward', false);

var SvgComponent$3N = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-feather",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 2,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 15,
    x2: 9,
    y2: 15
  }));
};
var ForwardRef$3N = /*#__PURE__*/forwardRef(SvgComponent$3N, 'feather', false);

var SvgComponent$3M = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-figma",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"
  }));
};
var ForwardRef$3M = /*#__PURE__*/forwardRef(SvgComponent$3M, 'figma', false);

var SvgComponent$3L = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-minus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  }));
};
var ForwardRef$3L = /*#__PURE__*/forwardRef(SvgComponent$3L, 'file-minus', false);

var SvgComponent$3K = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-plus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 15,
    x2: 15,
    y2: 15
  }));
};
var ForwardRef$3K = /*#__PURE__*/forwardRef(SvgComponent$3K, 'file-plus', false);

var SvgComponent$3J = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file-text",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 8,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 8,
    y2: 17
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 9 9 9 8 9"
  }));
};
var ForwardRef$3J = /*#__PURE__*/forwardRef(SvgComponent$3J, 'file-text', false);

var SvgComponent$3I = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-file",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "13 2 13 9 20 9"
  }));
};
var ForwardRef$3I = /*#__PURE__*/forwardRef(SvgComponent$3I, 'file', false);

var SvgComponent$3H = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-film",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 2.18,
    ry: 2.18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 2,
    x2: 7,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 2,
    x2: 17,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 7,
    x2: 7,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 17,
    x2: 7,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 17,
    x2: 22,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 7,
    x2: 22,
    y2: 7
  }));
};
var ForwardRef$3H = /*#__PURE__*/forwardRef(SvgComponent$3H, 'film', false);

var SvgComponent$3G = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-filter",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  }));
};
var ForwardRef$3G = /*#__PURE__*/forwardRef(SvgComponent$3G, 'filter', false);

var SvgComponent$3F = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-flag",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 22,
    x2: 4,
    y2: 15
  }));
};
var ForwardRef$3F = /*#__PURE__*/forwardRef(SvgComponent$3F, 'flag', false);

var SvgComponent$3E = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-folder-minus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
};
var ForwardRef$3E = /*#__PURE__*/forwardRef(SvgComponent$3E, 'folder-minus', false);

var SvgComponent$3D = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-folder-plus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 11,
    x2: 12,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 14,
    x2: 15,
    y2: 14
  }));
};
var ForwardRef$3D = /*#__PURE__*/forwardRef(SvgComponent$3D, 'folder-plus', false);

var SvgComponent$3C = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-folder",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
  }));
};
var ForwardRef$3C = /*#__PURE__*/forwardRef(SvgComponent$3C, 'folder', false);

var SvgComponent$3B = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-framer",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"
  }));
};
var ForwardRef$3B = /*#__PURE__*/forwardRef(SvgComponent$3B, 'framer', false);

var SvgComponent$3A = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-frown",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16s-1.5-2-4-2-4 2-4 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }));
};
var ForwardRef$3A = /*#__PURE__*/forwardRef(SvgComponent$3A, 'frown', false);

var SvgComponent$3z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-gift",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22,
    x2: 12,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  }));
};
var ForwardRef$3z = /*#__PURE__*/forwardRef(SvgComponent$3z, 'gift', false);

var SvgComponent$3y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-git-branch",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 3,
    x2: 6,
    y2: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a9 9 0 0 1-9 9"
  }));
};
var ForwardRef$3y = /*#__PURE__*/forwardRef(SvgComponent$3y, 'git-branch', false);

var SvgComponent$3x = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-git-commit",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.05,
    y1: 12,
    x2: 7,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.01,
    y1: 12,
    x2: 22.96,
    y2: 12
  }));
};
var ForwardRef$3x = /*#__PURE__*/forwardRef(SvgComponent$3x, 'git-commit', false);

var SvgComponent$3w = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-git-merge",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 21V9a9 9 0 0 0 9 9"
  }));
};
var ForwardRef$3w = /*#__PURE__*/forwardRef(SvgComponent$3w, 'git-merge', false);

var SvgComponent$3v = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-git-pull-request",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6h3a2 2 0 0 1 2 2v7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 9,
    x2: 6,
    y2: 21
  }));
};
var ForwardRef$3v = /*#__PURE__*/forwardRef(SvgComponent$3v, 'git-pull-request', false);

var SvgComponent$3u = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-github",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
  }));
};
var ForwardRef$3u = /*#__PURE__*/forwardRef(SvgComponent$3u, 'github', false);

var SvgComponent$3t = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-gitlab",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"
  }));
};
var ForwardRef$3t = /*#__PURE__*/forwardRef(SvgComponent$3t, 'gitlab', false);

var SvgComponent$3s = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-globe",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
  }));
};
var ForwardRef$3s = /*#__PURE__*/forwardRef(SvgComponent$3s, 'globe', false);

var SvgComponent$3r = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-grid",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 3,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 7,
    height: 7
  }));
};
var ForwardRef$3r = /*#__PURE__*/forwardRef(SvgComponent$3r, 'grid', false);

var SvgComponent$3q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-hard-drive",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 12,
    x2: 2,
    y2: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 16,
    x2: 6.01,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 16,
    x2: 10.01,
    y2: 16
  }));
};
var ForwardRef$3q = /*#__PURE__*/forwardRef(SvgComponent$3q, 'hard-drive', false);

var SvgComponent$3p = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-hash",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 9,
    x2: 20,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 15,
    x2: 20,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 3,
    x2: 8,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 3,
    x2: 14,
    y2: 21
  }));
};
var ForwardRef$3p = /*#__PURE__*/forwardRef(SvgComponent$3p, 'hash', false);

var SvgComponent$3o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-headphones",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 18v-6a9 9 0 0 1 18 0v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
  }));
};
var ForwardRef$3o = /*#__PURE__*/forwardRef(SvgComponent$3o, 'headphones', false);

var SvgComponent$3n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-heart",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
  }));
};
var ForwardRef$3n = /*#__PURE__*/forwardRef(SvgComponent$3n, 'heart', false);

var SvgComponent$3m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-help-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12.01,
    y2: 17
  }));
};
var ForwardRef$3m = /*#__PURE__*/forwardRef(SvgComponent$3m, 'help-circle', false);

var SvgComponent$3l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-hexagon",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }));
};
var ForwardRef$3l = /*#__PURE__*/forwardRef(SvgComponent$3l, 'hexagon', false);

var SvgComponent$3k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-home",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 22 9 12 15 12 15 22"
  }));
};
var ForwardRef$3k = /*#__PURE__*/forwardRef(SvgComponent$3k, 'home', false);

var SvgComponent$3j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-image",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 15 16 10 5 21"
  }));
};
var ForwardRef$3j = /*#__PURE__*/forwardRef(SvgComponent$3j, 'image', false);

var SvgComponent$3i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-inbox",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "22 12 16 12 14 15 10 15 8 12 2 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"
  }));
};
var ForwardRef$3i = /*#__PURE__*/forwardRef(SvgComponent$3i, 'inbox', false);

var SvgComponent$3h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-info",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12.01,
    y2: 8
  }));
};
var ForwardRef$3h = /*#__PURE__*/forwardRef(SvgComponent$3h, 'info', false);

var SvgComponent$3g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-instagram",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 6.5,
    x2: 17.51,
    y2: 6.5
  }));
};
var ForwardRef$3g = /*#__PURE__*/forwardRef(SvgComponent$3g, 'instagram', false);

var SvgComponent$3f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-italic",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 4,
    x2: 10,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 20,
    x2: 5,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 4,
    x2: 9,
    y2: 20
  }));
};
var ForwardRef$3f = /*#__PURE__*/forwardRef(SvgComponent$3f, 'italic', false);

var SvgComponent$3e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-key",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"
  }));
};
var ForwardRef$3e = /*#__PURE__*/forwardRef(SvgComponent$3e, 'key', false);

var SvgComponent$3d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-layers",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 2 7 12 12 22 7 12 2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 17 12 22 22 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "2 12 12 17 22 12"
  }));
};
var ForwardRef$3d = /*#__PURE__*/forwardRef(SvgComponent$3d, 'layers', false);

var SvgComponent$3c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-layout",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 9,
    x2: 21,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 21,
    x2: 9,
    y2: 9
  }));
};
var ForwardRef$3c = /*#__PURE__*/forwardRef(SvgComponent$3c, 'layout', false);

var SvgComponent$3b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-life-buoy",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 9.17,
    y2: 9.17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 14.83,
    x2: 19.07,
    y2: 19.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 19.07,
    y2: 4.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.83,
    y1: 9.17,
    x2: 18.36,
    y2: 5.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 9.17,
    y2: 14.83
  }));
};
var ForwardRef$3b = /*#__PURE__*/forwardRef(SvgComponent$3b, 'life-buoy', false);

var SvgComponent$3a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-link-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$3a = /*#__PURE__*/forwardRef(SvgComponent$3a, 'link-2', false);

var SvgComponent$39 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-link",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
  }));
};
var ForwardRef$39 = /*#__PURE__*/forwardRef(SvgComponent$39, 'link', false);

var SvgComponent$38 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-linkedin",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 9,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 2
  }));
};
var ForwardRef$38 = /*#__PURE__*/forwardRef(SvgComponent$38, 'linkedin', false);

var SvgComponent$37 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-list",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 21,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 3.01,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 3.01,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 3.01,
    y2: 18
  }));
};
var ForwardRef$37 = /*#__PURE__*/forwardRef(SvgComponent$37, 'list', false);

var SvgComponent$36 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-loader",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 7.76,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 16.24,
    x2: 19.07,
    y2: 19.07
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 6,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 19.07,
    x2: 7.76,
    y2: 16.24
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 7.76,
    x2: 19.07,
    y2: 4.93
  }));
};
var ForwardRef$36 = /*#__PURE__*/forwardRef(SvgComponent$36, 'loader', false);

var SvgComponent$35 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-lock",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }));
};
var ForwardRef$35 = /*#__PURE__*/forwardRef(SvgComponent$35, 'lock', false);

var SvgComponent$34 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-log-in",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "10 17 15 12 10 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 3,
    y2: 12
  }));
};
var ForwardRef$34 = /*#__PURE__*/forwardRef(SvgComponent$34, 'log-in', false);

var SvgComponent$33 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-log-out",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 17 21 12 16 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 9,
    y2: 12
  }));
};
var ForwardRef$33 = /*#__PURE__*/forwardRef(SvgComponent$33, 'log-out', false);

var SvgComponent$32 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-mail",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22,6 12,13 2,6"
  }));
};
var ForwardRef$32 = /*#__PURE__*/forwardRef(SvgComponent$32, 'mail', false);

var SvgComponent$31 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-map-pin",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  }));
};
var ForwardRef$31 = /*#__PURE__*/forwardRef(SvgComponent$31, 'map-pin', false);

var SvgComponent$30 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-map",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 2,
    x2: 8,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 6,
    x2: 16,
    y2: 22
  }));
};
var ForwardRef$30 = /*#__PURE__*/forwardRef(SvgComponent$30, 'map', false);

var SvgComponent$2$ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-maximize-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 21 3 21 3 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 3,
    x2: 14,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 10,
    y2: 14
  }));
};
var ForwardRef$2$ = /*#__PURE__*/forwardRef(SvgComponent$2$, 'maximize-2', false);

var SvgComponent$2_ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-maximize",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
  }));
};
var ForwardRef$2_ = /*#__PURE__*/forwardRef(SvgComponent$2_, 'maximize', false);

var SvgComponent$2Z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-meh",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 15,
    x2: 16,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }));
};
var ForwardRef$2Z = /*#__PURE__*/forwardRef(SvgComponent$2Z, 'meh', false);

var SvgComponent$2Y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-menu",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 12,
    x2: 21,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 18,
    x2: 21,
    y2: 18
  }));
};
var ForwardRef$2Y = /*#__PURE__*/forwardRef(SvgComponent$2Y, 'menu', false);

var SvgComponent$2X = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-message-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
  }));
};
var ForwardRef$2X = /*#__PURE__*/forwardRef(SvgComponent$2X, 'message-circle', false);

var SvgComponent$2W = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-message-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  }));
};
var ForwardRef$2W = /*#__PURE__*/forwardRef(SvgComponent$2W, 'message-square', false);

var SvgComponent$2V = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-mic-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 16,
    y2: 23
  }));
};
var ForwardRef$2V = /*#__PURE__*/forwardRef(SvgComponent$2V, 'mic-off', false);

var SvgComponent$2U = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-mic",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10v2a7 7 0 0 1-14 0v-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 23,
    x2: 16,
    y2: 23
  }));
};
var ForwardRef$2U = /*#__PURE__*/forwardRef(SvgComponent$2U, 'mic', false);

var SvgComponent$2T = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-minimize-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "4 14 10 14 10 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20 10 14 10 14 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 10,
    y2: 14
  }));
};
var ForwardRef$2T = /*#__PURE__*/forwardRef(SvgComponent$2T, 'minimize-2', false);

var SvgComponent$2S = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-minimize",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
  }));
};
var ForwardRef$2S = /*#__PURE__*/forwardRef(SvgComponent$2S, 'minimize', false);

var SvgComponent$2R = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-minus-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$2R = /*#__PURE__*/forwardRef(SvgComponent$2R, 'minus-circle', false);

var SvgComponent$2Q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-minus-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$2Q = /*#__PURE__*/forwardRef(SvgComponent$2Q, 'minus-square', false);

var SvgComponent$2P = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-minus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
};
var ForwardRef$2P = /*#__PURE__*/forwardRef(SvgComponent$2P, 'minus', false);

var SvgComponent$2O = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-monitor",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 14,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 21,
    x2: 16,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 21
  }));
};
var ForwardRef$2O = /*#__PURE__*/forwardRef(SvgComponent$2O, 'monitor', false);

var SvgComponent$2N = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-moon",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
  }));
};
var ForwardRef$2N = /*#__PURE__*/forwardRef(SvgComponent$2N, 'moon', false);

var SvgComponent$2M = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-more-horizontal",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  }));
};
var ForwardRef$2M = /*#__PURE__*/forwardRef(SvgComponent$2M, 'more-horizontal', false);

var SvgComponent$2L = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-more-vertical",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 19,
    r: 1
  }));
};
var ForwardRef$2L = /*#__PURE__*/forwardRef(SvgComponent$2L, 'more-vertical', false);

var SvgComponent$2K = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-mouse-pointer",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13l6 6"
  }));
};
var ForwardRef$2K = /*#__PURE__*/forwardRef(SvgComponent$2K, 'mouse-pointer', false);

var SvgComponent$2J = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-move",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "5 9 2 12 5 15"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "9 5 12 2 15 5"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15 19 12 22 9 19"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "19 9 22 12 19 15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 22,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22
  }));
};
var ForwardRef$2J = /*#__PURE__*/forwardRef(SvgComponent$2J, 'move', false);

var SvgComponent$2I = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-music",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 18V5l12-2v13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 3
  }));
};
var ForwardRef$2I = /*#__PURE__*/forwardRef(SvgComponent$2I, 'music', false);

var SvgComponent$2H = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-navigation-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 19 21 12 17 5 21 12 2"
  }));
};
var ForwardRef$2H = /*#__PURE__*/forwardRef(SvgComponent$2H, 'navigation-2', false);

var SvgComponent$2G = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-navigation",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "3 11 22 2 13 21 11 13 3 11"
  }));
};
var ForwardRef$2G = /*#__PURE__*/forwardRef(SvgComponent$2G, 'navigation', false);

var SvgComponent$2F = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-octagon",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }));
};
var ForwardRef$2F = /*#__PURE__*/forwardRef(SvgComponent$2F, 'octagon', false);

var SvgComponent$2E = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-package",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 9.4,
    x2: 7.5,
    y2: 4.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "3.27 6.96 12 12.01 20.73 6.96"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 22.08,
    x2: 12,
    y2: 12
  }));
};
var ForwardRef$2E = /*#__PURE__*/forwardRef(SvgComponent$2E, 'package', false);

var SvgComponent$2D = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-paperclip",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
  }));
};
var ForwardRef$2D = /*#__PURE__*/forwardRef(SvgComponent$2D, 'paperclip', false);

var SvgComponent$2C = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pause-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 15,
    x2: 10,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 15,
    x2: 14,
    y2: 9
  }));
};
var ForwardRef$2C = /*#__PURE__*/forwardRef(SvgComponent$2C, 'pause-circle', false);

var SvgComponent$2B = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pause",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 4,
    height: 16
  }));
};
var ForwardRef$2B = /*#__PURE__*/forwardRef(SvgComponent$2B, 'pause', false);

var SvgComponent$2A = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pen-tool",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 19l7-7 3 3-7 7-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2l7.586 7.586"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 2
  }));
};
var ForwardRef$2A = /*#__PURE__*/forwardRef(SvgComponent$2A, 'pen-tool', false);

var SvgComponent$2z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-percent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 5,
    y2: 19
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 2.5
  }));
};
var ForwardRef$2z = /*#__PURE__*/forwardRef(SvgComponent$2z, 'percent', false);

var SvgComponent$2y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-call",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2y = /*#__PURE__*/forwardRef(SvgComponent$2y, 'phone-call', false);

var SvgComponent$2x = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-forwarded",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "19 1 23 5 19 9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 5,
    x2: 23,
    y2: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2x = /*#__PURE__*/forwardRef(SvgComponent$2x, 'phone-forwarded', false);

var SvgComponent$2w = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-incoming",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 2 16 8 22 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 16,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2w = /*#__PURE__*/forwardRef(SvgComponent$2w, 'phone-incoming', false);

var SvgComponent$2v = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-missed",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 17,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 1,
    x2: 23,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2v = /*#__PURE__*/forwardRef(SvgComponent$2v, 'phone-missed', false);

var SvgComponent$2u = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 1,
    x2: 1,
    y2: 23
  }));
};
var ForwardRef$2u = /*#__PURE__*/forwardRef(SvgComponent$2u, 'phone-off', false);

var SvgComponent$2t = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone-outgoing",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "23 7 23 1 17 1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 8,
    x2: 23,
    y2: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2t = /*#__PURE__*/forwardRef(SvgComponent$2t, 'phone-outgoing', false);

var SvgComponent$2s = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-phone",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
  }));
};
var ForwardRef$2s = /*#__PURE__*/forwardRef(SvgComponent$2s, 'phone', false);

var SvgComponent$2r = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pie-chart",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.21 15.89A10 10 0 1 1 8 2.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12A10 10 0 0 0 12 2v10z"
  }));
};
var ForwardRef$2r = /*#__PURE__*/forwardRef(SvgComponent$2r, 'pie-chart', false);

var SvgComponent$2q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-play-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10 8 16 12 10 16 10 8"
  }));
};
var ForwardRef$2q = /*#__PURE__*/forwardRef(SvgComponent$2q, 'play-circle', false);

var SvgComponent$2p = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-play",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};
var ForwardRef$2p = /*#__PURE__*/forwardRef(SvgComponent$2p, 'play', false);

var SvgComponent$2o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-plus-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$2o = /*#__PURE__*/forwardRef(SvgComponent$2o, 'plus-circle', false);

var SvgComponent$2n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-plus-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 12,
    x2: 16,
    y2: 12
  }));
};
var ForwardRef$2n = /*#__PURE__*/forwardRef(SvgComponent$2n, 'plus-square', false);

var SvgComponent$2m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-plus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 5,
    x2: 12,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12,
    x2: 19,
    y2: 12
  }));
};
var ForwardRef$2m = /*#__PURE__*/forwardRef(SvgComponent$2m, 'plus', false);

var SvgComponent$2l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-pocket",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 10 12 14 16 10"
  }));
};
var ForwardRef$2l = /*#__PURE__*/forwardRef(SvgComponent$2l, 'pocket', false);

var SvgComponent$2k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-power",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 6.64a9 9 0 1 1-12.73 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 12
  }));
};
var ForwardRef$2k = /*#__PURE__*/forwardRef(SvgComponent$2k, 'power', false);

var SvgComponent$2j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-printer",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 6 2 18 2 18 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 12,
    height: 8
  }));
};
var ForwardRef$2j = /*#__PURE__*/forwardRef(SvgComponent$2j, 'printer', false);

var SvgComponent$2i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-radio",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"
  }));
};
var ForwardRef$2i = /*#__PURE__*/forwardRef(SvgComponent$2i, 'radio', false);

var SvgComponent$2h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-refresh-ccw",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23 20 23 14 17 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
  }));
};
var ForwardRef$2h = /*#__PURE__*/forwardRef(SvgComponent$2h, 'refresh-ccw', false);

var SvgComponent$2g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-refresh-cw",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1 20 1 14 7 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
  }));
};
var ForwardRef$2g = /*#__PURE__*/forwardRef(SvgComponent$2g, 'refresh-cw', false);

var SvgComponent$2f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-repeat",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "17 1 21 5 17 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11V9a4 4 0 0 1 4-4h14"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 23 3 19 7 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13v2a4 4 0 0 1-4 4H3"
  }));
};
var ForwardRef$2f = /*#__PURE__*/forwardRef(SvgComponent$2f, 'repeat', false);

var SvgComponent$2e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-rewind",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "11 19 2 12 11 5 11 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22 19 13 12 22 5 22 19"
  }));
};
var ForwardRef$2e = /*#__PURE__*/forwardRef(SvgComponent$2e, 'rewind', false);

var SvgComponent$2d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-rotate-ccw",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "1 4 1 10 7 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
  }));
};
var ForwardRef$2d = /*#__PURE__*/forwardRef(SvgComponent$2d, 'rotate-ccw', false);

var SvgComponent$2c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-rotate-cw",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "23 4 23 10 17 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
  }));
};
var ForwardRef$2c = /*#__PURE__*/forwardRef(SvgComponent$2c, 'rotate-cw', false);

var SvgComponent$2b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-rss",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 11a9 9 0 0 1 9 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a16 16 0 0 1 16 16"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 1
  }));
};
var ForwardRef$2b = /*#__PURE__*/forwardRef(SvgComponent$2b, 'rss', false);

var SvgComponent$2a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-save",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 21 17 13 7 13 7 21"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7 3 7 8 15 8"
  }));
};
var ForwardRef$2a = /*#__PURE__*/forwardRef(SvgComponent$2a, 'save', false);

var SvgComponent$29 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-scissors",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 4,
    x2: 8.12,
    y2: 15.88
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.47,
    y1: 14.48,
    x2: 20,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.12,
    y1: 8.12,
    x2: 12,
    y2: 12
  }));
};
var ForwardRef$29 = /*#__PURE__*/forwardRef(SvgComponent$29, 'scissors', false);

var SvgComponent$28 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-search",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  }));
};
var ForwardRef$28 = /*#__PURE__*/forwardRef(SvgComponent$28, 'search', false);

var SvgComponent$27 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-send",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 2,
    x2: 11,
    y2: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22 2 15 22 11 13 2 9 22 2"
  }));
};
var ForwardRef$27 = /*#__PURE__*/forwardRef(SvgComponent$27, 'send', false);

var SvgComponent$26 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-server",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 8,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 20,
    height: 8,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 6.01,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 6.01,
    y2: 18
  }));
};
var ForwardRef$26 = /*#__PURE__*/forwardRef(SvgComponent$26, 'server', false);

var SvgComponent$25 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-settings",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  }));
};
var ForwardRef$25 = /*#__PURE__*/forwardRef(SvgComponent$25, 'settings', false);

var SvgComponent$24 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-share-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59,
    y1: 13.51,
    x2: 15.42,
    y2: 17.49
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.41,
    y1: 6.51,
    x2: 8.59,
    y2: 10.49
  }));
};
var ForwardRef$24 = /*#__PURE__*/forwardRef(SvgComponent$24, 'share-2', false);

var SvgComponent$23 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-share",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 6 12 2 8 6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 15
  }));
};
var ForwardRef$23 = /*#__PURE__*/forwardRef(SvgComponent$23, 'share', false);

var SvgComponent$22 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-shield-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$22 = /*#__PURE__*/forwardRef(SvgComponent$22, 'shield-off', false);

var SvgComponent$21 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-shield",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
  }));
};
var ForwardRef$21 = /*#__PURE__*/forwardRef(SvgComponent$21, 'shield', false);

var SvgComponent$20 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-shopping-bag",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 6,
    x2: 21,
    y2: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10a4 4 0 0 1-8 0"
  }));
};
var ForwardRef$20 = /*#__PURE__*/forwardRef(SvgComponent$20, 'shopping-bag', false);

var SvgComponent$1$ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-shopping-cart",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
  }));
};
var ForwardRef$1$ = /*#__PURE__*/forwardRef(SvgComponent$1$, 'shopping-cart', false);

var SvgComponent$1_ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-shuffle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 3 21 3 21 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 21,
    y2: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "21 16 21 21 16 21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 21,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 4,
    x2: 9,
    y2: 9
  }));
};
var ForwardRef$1_ = /*#__PURE__*/forwardRef(SvgComponent$1_, 'shuffle', false);

var SvgComponent$1Z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sidebar",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 21
  }));
};
var ForwardRef$1Z = /*#__PURE__*/forwardRef(SvgComponent$1Z, 'sidebar', false);

var SvgComponent$1Y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-skip-back",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "19 20 9 12 19 4 19 20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 19,
    x2: 5,
    y2: 5
  }));
};
var ForwardRef$1Y = /*#__PURE__*/forwardRef(SvgComponent$1Y, 'skip-back', false);

var SvgComponent$1X = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-skip-forward",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "5 4 15 12 5 20 5 4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 5,
    x2: 19,
    y2: 19
  }));
};
var ForwardRef$1X = /*#__PURE__*/forwardRef(SvgComponent$1X, 'skip-forward', false);

var SvgComponent$1W = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-slack",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"
  }));
};
var ForwardRef$1W = /*#__PURE__*/forwardRef(SvgComponent$1W, 'slack', false);

var SvgComponent$1V = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-slash",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.93,
    y1: 4.93,
    x2: 19.07,
    y2: 19.07
  }));
};
var ForwardRef$1V = /*#__PURE__*/forwardRef(SvgComponent$1V, 'slash', false);

var SvgComponent$1U = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sliders",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 21,
    x2: 4,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 10,
    x2: 4,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 8,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 21,
    x2: 20,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 20,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14,
    x2: 7,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 16,
    x2: 23,
    y2: 16
  }));
};
var ForwardRef$1U = /*#__PURE__*/forwardRef(SvgComponent$1U, 'sliders', false);

var SvgComponent$1T = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-smartphone",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 14,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }));
};
var ForwardRef$1T = /*#__PURE__*/forwardRef(SvgComponent$1T, 'smartphone', false);

var SvgComponent$1S = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-smile",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14s1.5 2 4 2 4-2 4-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9.01,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 15.01,
    y2: 9
  }));
};
var ForwardRef$1S = /*#__PURE__*/forwardRef(SvgComponent$1S, 'smile', false);

var SvgComponent$1R = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-speaker",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 6,
    x2: 12.01,
    y2: 6
  }));
};
var ForwardRef$1R = /*#__PURE__*/forwardRef(SvgComponent$1R, 'speaker', false);

var SvgComponent$1Q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }));
};
var ForwardRef$1Q = /*#__PURE__*/forwardRef(SvgComponent$1Q, 'square', false);

var SvgComponent$1P = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-star",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  }));
};
var ForwardRef$1P = /*#__PURE__*/forwardRef(SvgComponent$1P, 'star', false);

var SvgComponent$1O = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-stop-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 6,
    height: 6
  }));
};
var ForwardRef$1O = /*#__PURE__*/forwardRef(SvgComponent$1O, 'stop-circle', false);

var SvgComponent$1N = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sun",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 1,
    x2: 12,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 21,
    x2: 12,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 4.22,
    x2: 5.64,
    y2: 5.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 18.36,
    x2: 19.78,
    y2: 19.78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 12,
    x2: 3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 12,
    x2: 23,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 19.78,
    x2: 5.64,
    y2: 18.36
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 5.64,
    x2: 19.78,
    y2: 4.22
  }));
};
var ForwardRef$1N = /*#__PURE__*/forwardRef(SvgComponent$1N, 'sun', false);

var SvgComponent$1M = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sunrise",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 10.22,
    x2: 5.64,
    y2: 11.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 3,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 23,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 11.64,
    x2: 19.78,
    y2: 10.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 22,
    x2: 1,
    y2: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 6 12 2 16 6"
  }));
};
var ForwardRef$1M = /*#__PURE__*/forwardRef(SvgComponent$1M, 'sunrise', false);

var SvgComponent$1L = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-sunset",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 18a5 5 0 0 0-10 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.22,
    y1: 10.22,
    x2: 5.64,
    y2: 11.64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 18,
    x2: 3,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18,
    x2: 23,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.36,
    y1: 11.64,
    x2: 19.78,
    y2: 10.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 22,
    x2: 1,
    y2: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 5 12 9 8 5"
  }));
};
var ForwardRef$1L = /*#__PURE__*/forwardRef(SvgComponent$1L, 'sunset', false);

var SvgComponent$1K = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-table",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"
  }));
};
var ForwardRef$1K = /*#__PURE__*/forwardRef(SvgComponent$1K, 'table', false);

var SvgComponent$1J = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-tablet",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 18,
    x2: 12.01,
    y2: 18
  }));
};
var ForwardRef$1J = /*#__PURE__*/forwardRef(SvgComponent$1J, 'tablet', false);

var SvgComponent$1I = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-tag",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7.01,
    y2: 7
  }));
};
var ForwardRef$1I = /*#__PURE__*/forwardRef(SvgComponent$1I, 'tag', false);

var SvgComponent$1H = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-target",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  }));
};
var ForwardRef$1H = /*#__PURE__*/forwardRef(SvgComponent$1H, 'target', false);

var SvgComponent$1G = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-terminal",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "4 17 10 11 4 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 20,
    y2: 19
  }));
};
var ForwardRef$1G = /*#__PURE__*/forwardRef(SvgComponent$1G, 'terminal', false);

var SvgComponent$1F = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-thermometer",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"
  }));
};
var ForwardRef$1F = /*#__PURE__*/forwardRef(SvgComponent$1F, 'thermometer', false);

var SvgComponent$1E = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-thumbs-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"
  }));
};
var ForwardRef$1E = /*#__PURE__*/forwardRef(SvgComponent$1E, 'thumbs-down', false);

var SvgComponent$1D = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-thumbs-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
  }));
};
var ForwardRef$1D = /*#__PURE__*/forwardRef(SvgComponent$1D, 'thumbs-up', false);

var SvgComponent$1C = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-toggle-left",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 22,
    height: 14,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 3
  }));
};
var ForwardRef$1C = /*#__PURE__*/forwardRef(SvgComponent$1C, 'toggle-left', false);

var SvgComponent$1B = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-toggle-right",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 22,
    height: 14,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 3
  }));
};
var ForwardRef$1B = /*#__PURE__*/forwardRef(SvgComponent$1B, 'toggle-right', false);

var SvgComponent$1A = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-tool",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
  }));
};
var ForwardRef$1A = /*#__PURE__*/forwardRef(SvgComponent$1A, 'tool', false);

var SvgComponent$1z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trash-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11,
    x2: 10,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 11,
    x2: 14,
    y2: 17
  }));
};
var ForwardRef$1z = /*#__PURE__*/forwardRef(SvgComponent$1z, 'trash-2', false);

var SvgComponent$1y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trash",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }));
};
var ForwardRef$1y = /*#__PURE__*/forwardRef(SvgComponent$1y, 'trash', false);

var SvgComponent$1x = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trello",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 3,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 3,
    height: 5
  }));
};
var ForwardRef$1x = /*#__PURE__*/forwardRef(SvgComponent$1x, 'trello', false);

var SvgComponent$1w = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trending-down",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "23 18 13.5 8.5 8.5 13.5 1 6"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 18 23 18 23 12"
  }));
};
var ForwardRef$1w = /*#__PURE__*/forwardRef(SvgComponent$1w, 'trending-down', false);

var SvgComponent$1v = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trending-up",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "23 6 13.5 15.5 8.5 10.5 1 18"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 6 23 6 23 12"
  }));
};
var ForwardRef$1v = /*#__PURE__*/forwardRef(SvgComponent$1v, 'trending-up', false);

var SvgComponent$1u = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-triangle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }));
};
var ForwardRef$1u = /*#__PURE__*/forwardRef(SvgComponent$1u, 'triangle', false);

var SvgComponent$1t = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-truck",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 15,
    height: 13
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16 8 20 8 23 11 23 16 16 16 16 8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 2.5
  }));
};
var ForwardRef$1t = /*#__PURE__*/forwardRef(SvgComponent$1t, 'truck', false);

var SvgComponent$1s = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-tv",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 20,
    height: 15,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 2 12 7 7 2"
  }));
};
var ForwardRef$1s = /*#__PURE__*/forwardRef(SvgComponent$1s, 'tv', false);

var SvgComponent$1r = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-twitch",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"
  }));
};
var ForwardRef$1r = /*#__PURE__*/forwardRef(SvgComponent$1r, 'twitch', false);

var SvgComponent$1q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-twitter",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
  }));
};
var ForwardRef$1q = /*#__PURE__*/forwardRef(SvgComponent$1q, 'twitter', false);

var SvgComponent$1p = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-type",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "4 7 4 4 20 4 20 7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  }));
};
var ForwardRef$1p = /*#__PURE__*/forwardRef(SvgComponent$1p, 'type', false);

var SvgComponent$1o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-umbrella",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"
  }));
};
var ForwardRef$1o = /*#__PURE__*/forwardRef(SvgComponent$1o, 'umbrella', false);

var SvgComponent$1n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-underline",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 21,
    x2: 20,
    y2: 21
  }));
};
var ForwardRef$1n = /*#__PURE__*/forwardRef(SvgComponent$1n, 'underline', false);

var SvgComponent$1m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-unlock",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 18,
    height: 11,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11V7a5 5 0 0 1 9.9-1"
  }));
};
var ForwardRef$1m = /*#__PURE__*/forwardRef(SvgComponent$1m, 'unlock', false);

var SvgComponent$1l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-upload-cloud",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 12,
    x2: 12,
    y2: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16 16 12 12 8 16"
  }));
};
var ForwardRef$1l = /*#__PURE__*/forwardRef(SvgComponent$1l, 'upload-cloud', false);

var SvgComponent$1k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-upload",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 8 12 3 7 8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 15
  }));
};
var ForwardRef$1k = /*#__PURE__*/forwardRef(SvgComponent$1k, 'upload', false);

var SvgComponent$1j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-check",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 11 19 13 23 9"
  }));
};
var ForwardRef$1j = /*#__PURE__*/forwardRef(SvgComponent$1j, 'user-check', false);

var SvgComponent$1i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-minus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  }));
};
var ForwardRef$1i = /*#__PURE__*/forwardRef(SvgComponent$1i, 'user-minus', false);

var SvgComponent$1h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-plus",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 11,
    x2: 17,
    y2: 11
  }));
};
var ForwardRef$1h = /*#__PURE__*/forwardRef(SvgComponent$1h, 'user-plus', false);

var SvgComponent$1g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user-x",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 8,
    x2: 23,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 8,
    x2: 18,
    y2: 13
  }));
};
var ForwardRef$1g = /*#__PURE__*/forwardRef(SvgComponent$1g, 'user-x', false);

var SvgComponent$1f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  }));
};
var ForwardRef$1f = /*#__PURE__*/forwardRef(SvgComponent$1f, 'user', false);

var SvgComponent$1e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-users",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }));
};
var ForwardRef$1e = /*#__PURE__*/forwardRef(SvgComponent$1e, 'users', false);

var SvgComponent$1d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-video-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$1d = /*#__PURE__*/forwardRef(SvgComponent$1d, 'video-off', false);

var SvgComponent$1c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-video",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "23 7 16 12 23 17 23 7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 5,
    width: 15,
    height: 14,
    rx: 2,
    ry: 2
  }));
};
var ForwardRef$1c = /*#__PURE__*/forwardRef(SvgComponent$1c, 'video', false);

var SvgComponent$1b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-voicemail",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 11.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 16,
    x2: 18.5,
    y2: 16
  }));
};
var ForwardRef$1b = /*#__PURE__*/forwardRef(SvgComponent$1b, 'voicemail', false);

var SvgComponent$1a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-volume-1",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54 8.46a5 5 0 0 1 0 7.07"
  }));
};
var ForwardRef$1a = /*#__PURE__*/forwardRef(SvgComponent$1a, 'volume-1', false);

var SvgComponent$19 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-volume-2",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"
  }));
};
var ForwardRef$19 = /*#__PURE__*/forwardRef(SvgComponent$19, 'volume-2', false);

var SvgComponent$18 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-volume-x",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 9,
    x2: 17,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 9,
    x2: 23,
    y2: 15
  }));
};
var ForwardRef$18 = /*#__PURE__*/forwardRef(SvgComponent$18, 'volume-x', false);

var SvgComponent$17 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-volume",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }));
};
var ForwardRef$17 = /*#__PURE__*/forwardRef(SvgComponent$17, 'volume', false);

var SvgComponent$16 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-watch",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 9 12 12 13.5 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"
  }));
};
var ForwardRef$16 = /*#__PURE__*/forwardRef(SvgComponent$16, 'watch', false);

var SvgComponent$15 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-wifi-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.72 11.06A10.94 10.94 0 0 1 19 12.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.55a10.94 10.94 0 0 1 5.17-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71 5.05A16 16 0 0 1 22.58 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42 9a15.91 15.91 0 0 1 4.7-2.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12.01,
    y2: 20
  }));
};
var ForwardRef$15 = /*#__PURE__*/forwardRef(SvgComponent$15, 'wifi-off', false);

var SvgComponent$14 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-wifi",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.55a11 11 0 0 1 14.08 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42 9a16 16 0 0 1 21.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53 16.11a6 6 0 0 1 6.95 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12.01,
    y2: 20
  }));
};
var ForwardRef$14 = /*#__PURE__*/forwardRef(SvgComponent$14, 'wifi', false);

var SvgComponent$13 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-wind",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"
  }));
};
var ForwardRef$13 = /*#__PURE__*/forwardRef(SvgComponent$13, 'wind', false);

var SvgComponent$12 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x-circle",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
};
var ForwardRef$12 = /*#__PURE__*/forwardRef(SvgComponent$12, 'x-circle', false);

var SvgComponent$11 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x-octagon",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }));
};
var ForwardRef$11 = /*#__PURE__*/forwardRef(SvgComponent$11, 'x-octagon', false);

var SvgComponent$10 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x-square",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 15,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 9,
    x2: 9,
    y2: 15
  }));
};
var ForwardRef$10 = /*#__PURE__*/forwardRef(SvgComponent$10, 'x-square', false);

var SvgComponent$$ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-x",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 6,
    x2: 6,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 6,
    x2: 18,
    y2: 18
  }));
};
var ForwardRef$$ = /*#__PURE__*/forwardRef(SvgComponent$$, 'x', false);

var SvgComponent$_ = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-youtube",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
  }));
};
var ForwardRef$_ = /*#__PURE__*/forwardRef(SvgComponent$_, 'youtube', false);

var SvgComponent$Z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-zap-off",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "12.41 6.75 13 2 10.57 4.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.57 12.91 21 10 15.66 10"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8 8 3 14 12 14 11 22 16 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1,
    x2: 23,
    y2: 23
  }));
};
var ForwardRef$Z = /*#__PURE__*/forwardRef(SvgComponent$Z, 'zap-off', false);

var SvgComponent$Y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-zap",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("polygon", {
    points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2"
  }));
};
var ForwardRef$Y = /*#__PURE__*/forwardRef(SvgComponent$Y, 'zap', false);

var SvgComponent$X = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-zoom-in",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 8,
    x2: 11,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 14,
    y2: 11
  }));
};
var ForwardRef$X = /*#__PURE__*/forwardRef(SvgComponent$X, 'zoom-in', false);

var SvgComponent$W = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-zoom-out",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 21,
    x2: 16.65,
    y2: 16.65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 14,
    y2: 11
  }));
};
var ForwardRef$W = /*#__PURE__*/forwardRef(SvgComponent$W, 'zoom-out', false);

var SvgComponent$V = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.2667C17.6701 22.2667 22.2667 17.6702 22.2667 12.0001C22.2667 6.32994 17.6701 1.7334 12 1.7334C6.32988 1.7334 1.73334 6.32994 1.73334 12.0001C1.73334 17.6702 6.32988 22.2667 12 22.2667Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06667 18.5999L10.6556 13.3443L7.72223 12.4888L11.5111 8.6999L14.9333 5.3999L13.3445 10.6555L16.2778 11.511L12.4889 15.2999L9.06667 18.5999Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$V = /*#__PURE__*/forwardRef$1(SvgComponent$V, 'accents', false);

var SvgComponent$U = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 2L5 10L14.2857 18",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$U = /*#__PURE__*/forwardRef$1(SvgComponent$U, 'back', false);

var SvgComponent$T = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 24L18 34",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63495 23.8415L18.381 29.6828L33.3651 21.0479",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63495 18.1426V28.9362",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5397 14.2061L2.63495 18.2695L18 23.7299",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63495 17.8887L9.36511 8.61889L18.381 23.73L33.3651 15.3491L25.3651 1.63477L9.36511 8.61889",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63495 28.9366L18.381 35.0318L33.3651 26.6509",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3651 15.3491V26.6507",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 36,
    fill: "white",
    transform: "translate(2)"
  }))));
};
var ForwardRef$T = /*#__PURE__*/forwardRef$1(SvgComponent$T, 'belly-band', true);

var SvgComponent$S = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 7.25H9.62496C8.5204 7.25 8.62496 7.35457 8.62496 6.25V4.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6277 7.25H14.6277C13.5231 7.25 13.6277 7.35457 13.6277 6.25V4.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6277 12.7527H9.62765C8.52308 12.7527 8.62765 12.8573 8.62765 11.7527V10.2527",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6277 12.7527H14.6277C13.5231 12.7527 13.6277 12.8573 13.6277 11.7527V10.2527",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.125 21.25V3.75C19.125 2.64543 18.2296 1.75 17.125 1.75H7.125C6.02043 1.75 5.125 2.64543 5.125 3.75V21.25",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 21.25V17.25C14.125 16.1454 14.2295 16.25 13.125 16.25H11.125C10.0204 16.25 10.125 16.1454 10.125 17.25V21.25",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.125 22.25H21.875",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};
var ForwardRef$S = /*#__PURE__*/forwardRef$1(SvgComponent$S, 'building', false);

var SvgComponent$R = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 3H18C19.1046 3 20 3.89543 20 5V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V5C4 3.89543 4.89543 3 6 3Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10H4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5L4 15.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10L9.5 20.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10L15 20.5",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};
var ForwardRef$R = /*#__PURE__*/forwardRef$1(SvgComponent$R, 'calculator', false);

var SvgComponent$Q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5L11 15.5L15 11.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$Q = /*#__PURE__*/forwardRef$1(SvgComponent$Q, 'clipboard-check', false);

var SvgComponent$P = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9.91592H16.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.9159H16.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.9159H16.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.91592H7.51",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.9159H7.51",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.9159H7.51",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$P = /*#__PURE__*/forwardRef$1(SvgComponent$P, 'clipboard-list', false);

var SvgComponent$O = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29292 1.87883C2.9024 1.48831 2.26923 1.48831 1.87871 1.87883C1.48818 2.26936 1.48818 2.90252 1.87871 3.29304L8.94986 10.3642L1.87873 17.4353C1.4882 17.8259 1.4882 18.459 1.87873 18.8495C2.26925 19.2401 2.90242 19.2401 3.29294 18.8495L10.3641 11.7784L17.4351 18.8494C17.8256 19.2399 18.4587 19.2399 18.8493 18.8494C19.2398 18.4589 19.2398 17.8257 18.8493 17.4352L11.7783 10.3642L18.8493 3.2932C19.2398 2.90267 19.2398 2.26951 18.8493 1.87898C18.4588 1.48846 17.8256 1.48846 17.4351 1.87898L10.3641 8.94998L3.29292 1.87883Z",
    fill: "currentColor"
  }));
};
var ForwardRef$O = /*#__PURE__*/forwardRef$1(SvgComponent$O, 'close', false);

var SvgComponent$N = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 12H22",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V23M12 16L15 19M12 16L9 19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8V1M12 8L9 5M12 8L15 5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$N = /*#__PURE__*/forwardRef$1(SvgComponent$N, 'collapse', false);

var SvgComponent$M = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.4742 2.3299C18.5065 1.89003 17.011 1.89003 16.1312 2.3299L3.55118 8.31203C2.67145 8.75189 2.67143 9.10378 3.7271 9.10378H5.75049C6.80616 9.10378 8.47762 9.10378 9.44532 9.10378H26.2481C27.3037 9.10378 28.9752 9.10378 29.9429 9.10378H31.9663C33.022 9.10378 33.1099 8.75189 32.1422 8.31203L19.4742 2.3299Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77386 13.1504V25.9064",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4598 13.1504V25.9064",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1458 13.1504V25.9064",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8316 13.1504V25.9064",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63916 30.1294H31.8783",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 34H34.6055",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$M = /*#__PURE__*/forwardRef$1(SvgComponent$M, 'columns', false);

var SvgComponent$L = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2501 23.5688V32.4723",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0545 23.9565V32.86",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 17.6412L18.1393 22.6686L31.1924 14.0388L20.9437 11.2344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 17.6412L18.1393 22.6686L31.1924 14.0388L20.9437 11.2344",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 17.641L10.2733 9.56978L18.1393 22.6685L32.2982 15.76L24.9451 3.14014L10.2733 9.56978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 17.641L10.2733 9.56978L18.1393 22.6685L32.2982 15.76L24.9451 3.14014L10.2733 9.56978",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 20.4569V17.6411",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14001 24.3101V19.6133",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1386 15.897L18.8461 23.2272",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04706 18.6898L10.0339 14.9277L13.6591 21.0154",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2982 23.8084V16.2388",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.4382,
    height: 32,
    fill: "white",
    transform: "translate(3 2)"
  }))));
};
var ForwardRef$L = /*#__PURE__*/forwardRef$1(SvgComponent$L, 'corner-post', true);

var SvgComponent$K = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 24.3195V30.4451H6.61256V28.2462C6.61256 28.2462 12.5812 27.2252 13.8377 21.6493C15.0157 16.0734 16.6649 10.8116 22.555 9.71213V5.07861H16.6649",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61255 30.4451H17.0576V28.2462C17.0576 28.2462 23.0262 27.2252 24.2827 21.6493C25.4607 16.0734 27.1099 10.8116 33 9.71213V5.07861H22.555",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17.2513V5H11.8743",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$K = /*#__PURE__*/forwardRef$1(SvgComponent$K, 'crown-molding', false);

var SvgComponent$J = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 30.6492V12.0524C28 6.52356 23.5462 2 18 2C12.4538 2 8 6.52356 8 12.0524V30.6492",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 29V12.5281C12 8.88449 14.6512 6 18 6C21.3488 6 24 8.9604 24 12.5281V29H12V29Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 20L21 20",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 34H31.4712",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$J = /*#__PURE__*/forwardRef$1(SvgComponent$J, 'doors-trim', true);

var SvgComponent$I = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 3.89543 6.89543 3 8 3H17C18.1046 3 19 3.89543 19 5V21H6V5Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.25,
    cy: 12.25,
    r: 1.25,
    stroke: "currentColor"
  }));
};
var ForwardRef$I = /*#__PURE__*/forwardRef$1(SvgComponent$I, 'doors', false);

var SvgComponent$H = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4451 32.5133V32.0989C27.4472 31.7048 27.5339 31.3159 27.6995 30.9583C27.8651 30.6008 28.1057 30.283 28.4048 30.0266L31.8622 27.06C32.1885 26.7832 32.4509 26.439 32.6317 26.0512C32.8124 25.6634 32.9071 25.2411 32.9093 24.8132V21.0068",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7757 23.3735V24.955C28.7813 25.2154 28.7305 25.474 28.627 25.7131C28.5235 25.9521 28.3696 26.166 28.1758 26.3401L24.3913 29.6121C24.16 29.8124 23.9749 30.0604 23.8488 30.339C23.7226 30.6177 23.6584 30.9204 23.6605 31.2263V32.4806",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 24.7261V32.3389",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 27.8347V24.4972L16.8984 23.4502L16.8766 26.8422L20.0177 27.8347Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 24.497L32.9093 17.5059V20.5379L20.0177 27.8344V24.497Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 16.2954L32.9093 17.3206",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 25.457V27.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.9639V18.182V21.7485L16.5603 26.4383V22.7737L3.09064 17.9639Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.604,
    fill: "white",
    transform: "translate(2 3)"
  }))));
};
var ForwardRef$H = /*#__PURE__*/forwardRef$1(SvgComponent$H, 'downspouts', true);

var SvgComponent$G = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.6715 11H13.3431C13.6967 11 14.0181 11.1394 14.2538 11.3753C14.4896 11.6113 14.6289 11.9223 14.6289 12.2761C14.6289 12.63 14.4896 12.9517 14.2538 13.1769C14.0181 13.4021 13.7074 13.5523 13.3431 13.5523H11.6715H10",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6289 8.44775H12.9573H11.2858C10.9322 8.44775 10.6108 8.58716 10.375 8.82309C10.1393 9.04829 10 9.37 10 9.72389C10 10.0778 10.1393 10.3995 10.375 10.6247C10.6108 10.8499 10.9215 11 11.2858 11H12.9573",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3145 7V8.44772",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3145 13.5522V15",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 21.6038H6C4.89543 21.6038 4 20.7084 4 19.6038V5.39551C4 4.29094 4.89543 3.39551 6 3.39551H18C19.1046 3.39551 20 4.29094 20 5.39551V16.0622L15.1304 21.6038Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 21.6042V18.0625C15.1304 16.9579 16.0259 16.0625 17.1304 16.0625H20",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$G = /*#__PURE__*/forwardRef$1(SvgComponent$G, 'estimate', false);

var SvgComponent$F = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 12H22",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1V8M12 1L15 4M12 1L9 4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23V16M12 23L9 20M12 23L15 20",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$F = /*#__PURE__*/forwardRef$1(SvgComponent$F, 'expand', false);

var SvgComponent$E = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4451 32.5133V32.0989C27.4472 31.7048 27.5339 31.3159 27.6995 30.9583C27.8651 30.6008 28.1057 30.283 28.4048 30.0266L31.8622 27.06C32.1885 26.7832 32.4509 26.439 32.6317 26.0512C32.8124 25.6634 32.9071 25.2411 32.9093 24.8132V21.0068",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7757 23.3735V24.955C28.7813 25.2154 28.7305 25.474 28.627 25.7131C28.5235 25.9521 28.3696 26.166 28.1758 26.3401L24.3913 29.6121C24.16 29.8124 23.9749 30.0604 23.8488 30.339C23.7226 30.6177 23.6584 30.9204 23.6605 31.2263V32.4806",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 24.7261V32.3389",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 27.8347V24.4972L16.8984 23.4502L16.8766 26.8422L20.0177 27.8347Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 24.497L32.9093 17.5059V20.5379L20.0177 27.8344V24.497Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 16.2954L32.9093 17.3206",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 25.457V27.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 26.4496V20.6582",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.9639V18.182V21.7485L16.5603 26.4383V22.7737L3.09064 17.9639Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.604,
    fill: "white",
    transform: "translate(2 3)"
  }))));
};
var ForwardRef$E = /*#__PURE__*/forwardRef$1(SvgComponent$E, 'fascia', true);

var SvgComponent$D = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.47 24.94L23.17 14.5L29.92 24.35L29.33 30.19",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17 14.5L9.21 15.07L8.81 17.67L22.71 17.29L23.17 14.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53003 24.1199L9.20003 15.3599",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.17 14.5002L27.91 14.2002L34.55 24.1102L29.92 24.3502L23.17 14.5002Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 14.37L16.72 9.58L8.66 15.36L4 15.38L16.95 6L27.93 14.29L23.85 14.37Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.3799L7.67 18.7599",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 14.6699L22.59 18.6899L29.64 28.7999L29.93 24.2799L23.23 14.6699Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.55,
    height: 26.19,
    fill: "white",
    transform: "translate(3 5)"
  }))));
};
var ForwardRef$D = /*#__PURE__*/forwardRef$1(SvgComponent$D, 'frieze-board', true);

var SvgComponent$C = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.71478 30.5584V14.6108C9.71478 14.1912 10.1345 13.7715 10.5541 13.7715H25.9141C26.3338 13.7715 26.7535 14.1912 26.7535 14.6108V30.5584",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7535 34H9.71478",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 17.2974H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 20.5703H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 23.9277H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 27.2012H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 30.4751H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08398 20.2348V12.7646C3.08398 11.5895 3.92332 10.1626 4.8466 9.57508L16.4296 2.44066C17.4368 1.85311 19.0315 1.85311 20.0387 2.44066L31.6217 9.57508C32.6289 10.1626 33.3843 11.5895 33.3843 12.7646V20.2348",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3843 20.2349V32.3214C33.3843 33.2447 32.6288 34.0001 31.7056 34.0001H19.8708C18.9475 34.0001 17.4367 34.0001 16.5134 34.0001H4.67869C3.75541 34.0001 3 33.2447 3 32.3214V20.2349",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$C = /*#__PURE__*/forwardRef$1(SvgComponent$C, 'garage-door-trim', true);

var SvgComponent$B = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.71478 30.5584V14.6108C9.71478 14.1912 10.1345 13.7715 10.5541 13.7715H25.9141C26.3338 13.7715 26.7535 14.1912 26.7535 14.6108V30.5584",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7535 34H9.71478",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 17.2974H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 20.5703H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 23.9277H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 27.2012H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4007 30.4751H24.1515",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08398 20.2348V12.7646C3.08398 11.5895 3.92332 10.1626 4.8466 9.57508L16.4296 2.44066C17.4368 1.85311 19.0315 1.85311 20.0387 2.44066L31.6217 9.57508C32.6289 10.1626 33.3843 11.5895 33.3843 12.7646V20.2348",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3843 20.2349V32.3214C33.3843 33.2447 32.6288 34.0001 31.7056 34.0001H19.8708C18.9475 34.0001 17.4367 34.0001 16.5134 34.0001H4.67869C3.75541 34.0001 3 33.2447 3 32.3214V20.2349",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$B = /*#__PURE__*/forwardRef$1(SvgComponent$B, 'garage-doors', false);

var SvgComponent$A = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 13C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20C9.55228 20 10 19.5523 10 19C10 18.4477 9.55228 18 9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11C14.4477 11 14 11.4477 14 12C14 12.5523 14.4477 13 15 13Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20C15.5523 20 16 19.5523 16 19C16 18.4477 15.5523 18 15 18C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$A = /*#__PURE__*/forwardRef$1(SvgComponent$A, 'grip-vertical', false);

var SvgComponent$z = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4451 32.5133V32.0989C27.4472 31.7048 27.5339 31.3159 27.6995 30.9583C27.8651 30.6008 28.1057 30.283 28.4048 30.0266L31.8622 27.06C32.1885 26.7832 32.4509 26.439 32.6317 26.0512C32.8124 25.6634 32.9071 25.2411 32.9093 24.8132V21.0068",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7757 23.3735V24.955C28.7813 25.2154 28.7305 25.474 28.627 25.7131C28.5235 25.9521 28.3696 26.166 28.1758 26.3401L24.3913 29.6121C24.16 29.8124 23.9749 30.0604 23.8488 30.339C23.7226 30.6177 23.6584 30.9204 23.6605 31.2263V32.4806",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 24.7261V32.3389",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 24.497L32.9093 17.5059V20.5379L20.0177 27.8344V24.497Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 16.2954L32.9093 17.3206",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 25.457V27.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 26.4496V20.6582",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.9639V18.182V21.7485L16.5603 26.4383V22.7737L3.09064 17.9639Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 27.8347V24.4972L16.8984 23.4502L16.8766 26.8422L20.0177 27.8347Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.604,
    fill: "white",
    transform: "translate(2 3)"
  }))));
};
var ForwardRef$z = /*#__PURE__*/forwardRef$1(SvgComponent$z, 'gutters', true);

var SvgComponent$y = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1446 6.9529L20.1452 6.95263L13.3414 0L7.67204 2.84272L9.93599 5.1562L5.40373 7.42817V10.5849C3.28034 11.6425 1.71428 13.3003 1.71428 15.3571C1.71428 17.2524 3.05753 18.8144 4.89288 19.8584C6.28689 20.6513 8.05049 21.2033 9.99946 21.4296C9.87932 21.4603 9.75846 21.4912 9.63754 21.5222C8.78194 21.7414 7.91893 21.9643 7.25777 22.1388C6.92763 22.2259 6.64504 22.3017 6.43799 22.3594C6.33507 22.388 6.24654 22.4133 6.17862 22.4339C6.14519 22.444 6.11132 22.4546 6.08087 22.465L6.07929 22.4656C6.06634 22.4699 5.99097 22.495 5.91795 22.5355C5.54015 22.7451 5.40411 23.2209 5.61408 23.5981C5.80954 23.9492 6.23584 24.0911 6.59859 23.9401L6.61769 23.9341L6.63318 23.9293C6.68406 23.9139 6.75918 23.8923 6.8582 23.8648C7.05503 23.81 7.3296 23.7363 7.65781 23.6496C8.31335 23.4766 9.17193 23.2549 10.0266 23.036C10.8808 22.8171 11.7296 22.6013 12.3649 22.4402C12.6825 22.3596 12.9467 22.2928 13.1315 22.2461L13.4215 22.1728C13.6249 22.1216 13.7991 21.9909 13.9051 21.8102C14.0111 21.6295 14.04 21.4139 13.9854 21.2116L12.9642 18.0421C12.8515 17.6254 12.4219 17.3788 12.0047 17.4913C11.5874 17.6037 11.3404 18.0326 11.453 18.4493C11.5656 18.8659 12.0318 19.9819 12.0318 19.9819C12.0212 19.9815 12.0106 19.9813 12 19.9813C9.48637 19.9813 7.24919 19.4001 5.66769 18.5005C4.06359 17.588 3.2795 16.4472 3.2795 15.3571C3.2795 14.3242 3.99538 13.2414 5.40373 12.3686V14.3411L9.94162 12.0694V5.16192L14.4753 9.79495V16.7109L20.1446 13.8682V13.7414C20.5299 14.27 20.7205 14.8197 20.7205 15.3571C20.7205 16.6707 19.5641 18.0649 17.29 19.0073C16.8908 19.1727 16.7015 19.63 16.8672 20.0285C17.0329 20.4271 17.4909 20.6161 17.8901 20.4507C20.3594 19.4273 22.2857 17.6372 22.2857 15.3571C22.2857 13.8416 21.4271 12.5394 20.1446 11.5445V6.9529ZM6.58713 23.9438L6.58944 23.943C6.57706 23.9478 6.57435 23.9482 6.58713 23.9438Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9422 15.5258L12.2081 16.1182V12.6586L9.9422 12.0693V15.5258Z",
    fill: "currentColor"
  }));
};
var ForwardRef$y = /*#__PURE__*/forwardRef$1(SvgComponent$y, 'hover-rotate', false);

var SvgComponent$x = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7931 9.98525L13.0323 0L4.9 4.08285L14.6609 14.0681V24L22.7936 19.9176L22.7931 9.98525Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5104 22.997L8.25999 22.1464V17.1824L11.5104 18.0286V22.997ZM1.75 10.5167V20.4447L8.25999 17.1824V7.25L1.75 10.5167Z",
    fill: "currentColor"
  }));
};
var ForwardRef$x = /*#__PURE__*/forwardRef$1(SvgComponent$x, 'hover-solid', false);

var SvgComponent$w = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1 10.1L12.9806 0.8L6.10001 4.25L15.4189 13.7681V22.8L22.1 19.5V10.1Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25999 17.1824V22.1464L11.5104 22.997V18.0286L8.25999 17.1824ZM8.25999 17.1824L1.75 20.4447V10.5167L8.25999 7.25V17.1824Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$w = /*#__PURE__*/forwardRef$1(SvgComponent$w, 'hover', false);

var SvgComponent$v = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M478.71 364.58zm-22 6.11l-27.83-15.9a15.92 15.92 0 0 1-6.94-19.2A184 184 0 1 1 256 72c5.89 0 11.71.29 17.46.83-.74-.07-1.48-.15-2.23-.21-8.49-.69-15.23-7.31-15.23-15.83v-32a16 16 0 0 1 15.34-16C266.24 8.46 261.18 8 256 8 119 8 8 119 8 256s111 248 248 248c98 0 182.42-56.95 222.71-139.42-4.13 7.86-14.23 10.55-22 6.11z",
    fill: "currentColor",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.23 72.62c-8.49-.69-15.23-7.31-15.23-15.83V24.73c0-9.11 7.67-16.78 16.77-16.17C401.92 17.18 504 124.67 504 256a246 246 0 0 1-25 108.24c-4 8.17-14.37 11-22.26 6.45l-27.84-15.9c-7.41-4.23-9.83-13.35-6.2-21.07A182.53 182.53 0 0 0 440 256c0-96.49-74.27-175.63-168.77-183.38z",
    fill: "currentColor"
  }));
};
var ForwardRef$v = /*#__PURE__*/forwardRef$1(SvgComponent$v, 'loader', false);

var SvgComponent$u = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6562_23583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61719 32.8062V28.0812M14.5403 32.8062V27.0312M20.4633 32.8062V28.0812M26.9249 32.8062V27.0312M32.848 32.8062V28.0812",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23438 24.9375V31.7625C3.23438 32.1125 3.44976 32.8125 4.3113 32.8125C5.17284 32.8125 26.9267 32.8125 37.6959 32.8125C38.0549 32.8125 38.7728 32.6025 38.7728 31.7625C38.7728 30.9225 38.7728 26.8625 38.7728 24.9375",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7656 15.4922H39.3041",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5312 11.8125L39.3005 15.4875L35.5312 19.1625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.226 15.4922H2.6875",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45673 19.1625L2.6875 15.4875L6.45673 11.8125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6562_23583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  }))));
};
var ForwardRef$u = /*#__PURE__*/forwardRef$1(SvgComponent$u, 'measure', false);

var SvgComponent$t = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M32.822 16.6597C32.822 18.2513 31.5654 19.5079 29.9738 19.5079H7.60732C6.01569 19.5079 4.75916 18.2513 4.75916 16.6597C4.75916 15.0681 6.01569 13.8115 7.60732 13.8115H30.0576C31.5654 13.8115 32.822 15.0681 32.822 16.6597Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 2C8.69633 2.8377 7.85863 9.95811 6.26701 9.95811H19.3351",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5812 2C28.8848 2.8377 29.7225 9.95811 31.3141 9.95811H19.3351",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0524 19.9268V34.0001",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61255 34.0001V19.9268",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4712 23.6123V33.9997",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8325 23.6123V33.9997",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1099 23.6123V33.9997",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$t = /*#__PURE__*/forwardRef$1(SvgComponent$t, 'pillisters', false);

var SvgComponent$s = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.6331 13.6074L23.1151 20.0912C23.7259 20.7087 23.7633 21.6596 23.2149 22.2154C22.6539 22.7711 21.6941 22.7341 21.0833 22.1166L14.6013 15.6328",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55268 7.06021C6.42008 6.66607 6.63706 6.45108 7.03486 6.58246L9.18057 7.31102C9.57838 7.4424 10.1811 7.34685 10.5066 7.09604L12.3268 5.73447C12.6643 5.48366 12.9295 5.61504 12.9295 6.03306L12.9054 8.31428C12.9054 8.7323 13.1706 9.26976 13.5202 9.50864L15.3766 10.8224C15.7142 11.0613 15.6659 11.3599 15.2681 11.4913L13.1104 12.1601C12.7126 12.2795 12.2786 12.7095 12.1581 13.1036L11.483 15.2774C11.3625 15.6715 11.0611 15.7193 10.82 15.3849L9.50605 13.5217C9.26496 13.1753 8.72251 12.9125 8.3006 12.9125L6.03433 12.9364C5.61242 12.9364 5.47982 12.6737 5.72092 12.3393L7.08308 10.5119C7.33623 10.1775 7.43266 9.5803 7.30006 9.18616L6.55268 7.06021Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17L6 19",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 9H1",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3V1",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7L19 6",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$s = /*#__PURE__*/forwardRef$1(SvgComponent$s, 'presets', false);

var SvgComponent$r = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4451 32.5133V32.0989C27.4472 31.7048 27.5339 31.3159 27.6995 30.9583C27.8651 30.6008 28.1057 30.283 28.4048 30.0266L31.8622 27.06C32.1885 26.7832 32.4509 26.439 32.6317 26.0512C32.8124 25.6634 32.9071 25.2411 32.9093 24.8132V21.0068",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7757 23.3735V24.955C28.7813 25.2154 28.7305 25.474 28.627 25.7131C28.5235 25.9521 28.3696 26.166 28.1758 26.3401L24.3913 29.6121C24.16 29.8124 23.9749 30.0604 23.8488 30.339C23.7226 30.6177 23.6584 30.9204 23.6605 31.2263V32.4806",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.964L8.95839 10.2421L16.5603 22.9811L29.7028 15.6845L22.9952 4.09082L8.95839 10.2421",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4513 22.6757L8.95841 10.2422L3.27606 17.7132",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8984 24.7261V32.3389",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 27.8347V24.4972L16.8984 23.4502L16.8766 26.8422L20.0177 27.8347Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 24.497L32.9093 17.5059V20.5379L20.0177 27.8344V24.497Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 16.2954L32.9093 17.3206",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 25.457V27.333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 26.4496V20.6582",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26447 17.9642L8.72936 14.8667L12.0232 20.8217",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09064 17.9639V18.182V21.7485L16.5603 26.4383V22.7737L3.09064 17.9639Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.604,
    fill: "white",
    transform: "translate(2 3)"
  }))));
};
var ForwardRef$r = /*#__PURE__*/forwardRef$1(SvgComponent$r, 'rake-board', true);

var SvgComponent$q = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.31836L16.5455 10.0002L13.6818 6.72745",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77268 16.5455C4.51814 16.5455 0.999956 13.0273 0.999956 8.77273C0.999956 4.51818 4.51814 1 8.77268 1C13.0272 1 16.5454 4.51818 16.5454 8.77273V10",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$q = /*#__PURE__*/forwardRef$1(SvgComponent$q, 'redo', false);

var SvgComponent$p = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.6916 14V16.0286C15.6916 16.5524 15.1308 16.981 14.4455 16.981L10.1962 17C9.51088 17 8.95013 16.5714 8.95013 16.0476V14.019",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71649 11.0816L11.38 7.53975C11.9034 7.02842 12.7632 7.02842 13.2866 7.53975L16.9501 11.0816",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52336 19.2627C7.2679 20.9838 9.67289 22.0563 12.3271 22.0563C14.9813 22.0563 17.3863 20.9838 19.1308 19.2627C20.8754 17.5417 21.947 15.1596 21.947 12.5282C21.947 9.89669 20.8629 7.51465 19.1308 5.79359C17.3863 4.07254 14.9813 3 12.3271 3C9.67289 3 7.2679 4.07254 5.52336 5.79359C3.77881 7.51465 2.70715 9.89669 2.70715 12.5282",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 10.9443L2.70716 13.0271L4.60123 11.1439",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$p = /*#__PURE__*/forwardRef$1(SvgComponent$p, 'reset', false);

var SvgComponent$o = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 13V19.0179C19 20.0852 17.9111 20.9641 16.5889 20.9641L8.41111 21C7.08889 21 6 20.1211 6 19.0538V13.0359",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9.30121L10.7824 2.70553C11.7543 1.76482 13.3458 1.76482 14.3071 2.70553L21.0895 9.30121",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$o = /*#__PURE__*/forwardRef$1(SvgComponent$o, 'roof', false);

var SvgComponent$n = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.2693 13.3295L12.6505 12.7107L11.9551 13.242C10.8078 14.1185 9.37578 14.6387 7.81937 14.6387C4.05313 14.6387 1 11.5856 1 7.81937C1 4.05313 4.05313 1 7.81937 1C11.5856 1 14.6387 4.05313 14.6387 7.81937C14.6387 9.37577 14.1185 10.8078 13.242 11.9551L12.7107 12.6505L13.3295 13.2693L18.9896 18.9294C18.995 18.9348 18.9972 18.9388 18.9983 18.9418C18.9998 18.9453 19.0008 18.9499 19.0008 18.9552C19.0008 18.9573 19.0007 18.9593 19.0004 18.9612C18.9999 18.9643 18.9991 18.9672 18.998 18.9698C18.9965 18.9735 18.9936 18.9791 18.9863 18.9863C18.9663 19.0063 18.9415 19.0017 18.9294 18.9896L13.2693 13.3295ZM7.81937 14.5536C11.5386 14.5536 14.5536 11.5386 14.5536 7.81937C14.5536 4.10017 11.5386 1.08516 7.81937 1.08516C4.10017 1.08516 1.08516 4.10017 1.08516 7.81937C1.08516 11.5386 4.10017 14.5536 7.81937 14.5536Z",
    stroke: "currentColor"
  }));
};
var ForwardRef$n = /*#__PURE__*/forwardRef$1(SvgComponent$n, 'search', false);

var SvgComponent$m = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H0V0H20V2Z",
    fill: "currentColor"
  }));
};
var ForwardRef$m = /*#__PURE__*/forwardRef$1(SvgComponent$m, 'selected', false);

var SvgComponent$l = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.2275V0.999029",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4L10 1L7 4",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 8H2V19H18V8C18 8 15.3479 8 13.2 8",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$l = /*#__PURE__*/forwardRef$1(SvgComponent$l, 'share', false);

var SvgComponent$k = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 31V6H26V31",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 21H15V30H23V21Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9H15V18H23V9Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12.25H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.5H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 18.75H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 25.25H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 28.5H7",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 6,
    height: 26,
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 9H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 12.25H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 15.5H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 18.75H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 22H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 25.25H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 28.5H33",
    strokeLinecap: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 6,
    height: 26,
    strokeLinejoin: "round",
    className: "stroke-accent"
  }));
};
var ForwardRef$k = /*#__PURE__*/forwardRef$1(SvgComponent$k, 'shutters', true);

var SvgComponent$j = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.47 24.94L22.17 14.5L28.92 24.35L28.33 30.16",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.17 14.5L8.21 15.07L7.81 17.67L21.71 17.29L22.17 14.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53003 24.1199L8.20003 15.3599",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.85 14.37L15.72 9.58L7.66 15.36L3 15.38L15.95 6L26.93 14.29L22.85 14.37Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.3799L6.67 18.7599",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.23 14.6699L21.59 18.6899L28.64 28.7899L28.93 24.2799L22.23 14.6699Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.17 14.5002L26.91 14.2002L33.55 24.1102L28.92 24.3502L22.17 14.5002Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.55,
    height: 26.16,
    fill: "white",
    transform: "translate(2 5)"
  }))));
};
var ForwardRef$j = /*#__PURE__*/forwardRef$1(SvgComponent$j, 'soffit', true);

var SvgComponent$i = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5A2.5 2.5 0 016.5 17H20M4 19.5A2.5 2.5 0 006.5 22H20V2h-1.488M4 19.5v-15A2.5 2.5 0 016.5 2h2.275",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.173 1.5l4.884-.304.604 6.135a.38.38 0 01-.614.31l-2.28-1.48-2.525 1.888a.38.38 0 01-.607-.319l.538-6.23z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$i = /*#__PURE__*/forwardRef$1(SvgComponent$i, 'storybook-2', false);

var SvgComponent$h = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2037_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.89 7.39321C14.6198 7.60369 13.0022 7.74682 13.0022 7.44755C13.0022 6.35507 12.3338 6.35507 12.0491 6.35507C11.7797 6.35507 11.025 6.4362 11.025 7.04851C11.025 7.67231 11.9894 8.02439 12.7693 8.43771C13.8768 9.02476 15.0186 9.73582 15.0186 11.5238C15.0186 13.2383 13.8256 13.9843 12.0498 13.9843C10.2167 13.9843 8.81474 13.5426 8.99537 10.9717C9.06656 10.6701 10.9972 10.742 10.9972 10.9717C10.9681 12.0325 11.41 12.2448 12.0208 12.2448C12.4899 12.2448 13.0027 11.9861 13.0027 11.5513C13.0027 10.8923 12.0108 10.5035 11.214 10.0565C10.1356 9.45109 9.06656 8.73851 9.06656 7.10286C9.06656 5.47103 9.98863 4.58264 11.9924 4.58264C13.9962 4.58264 14.89 5.3542 14.89 7.39321Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2037_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.699585)"
  }))));
};
var ForwardRef$h = /*#__PURE__*/forwardRef$1(SvgComponent$h, 'storybook', false);

var SvgComponent$g = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.148v7.186m0-7.186H4.699c0-3.764 2.235-5.134 3.352-5.348L8.642 3.3h6.716l.59 6.499c1.118.214 3.353 1.584 3.353 5.348H12zM6.882 3.301h10.236",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$g = /*#__PURE__*/forwardRef$1(SvgComponent$g, 'thumbtack', false);

var SvgComponent$f = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.684 8.124L8.1 11.44c-1.104.164-3.311 2.423-3.311 5.302H19.21c0-2.879-2.207-5.138-3.31-5.302l-.585-3.316",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.742v2.935",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6.581,
    rx: 5.165,
    ry: 1.859,
    stroke: "currentColor"
  }));
};
var ForwardRef$f = /*#__PURE__*/forwardRef$1(SvgComponent$f, 'thumbtacked', false);

var SvgComponent$e = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 21V3L21 21H3Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 17V12L12 17H7Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.06067L7.20711 7.35356",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.0607L10.2071 10.3536",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.0607L13.2071 13.3536",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.0607L16.2071 16.3536",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$e = /*#__PURE__*/forwardRef$1(SvgComponent$e, 'triangle-ruler', false);

var SvgComponent$d = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.71338 22.952V11.4408C6.71338 8.48511 9.14329 6.07812 12.0966 6.07812H12.8816C15.8473 6.07812 18.2648 8.49758 18.2648 11.4408V22.952H6.71338Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 22.952V10.9794C3 6.04074 7.07477 2 12.0592 2H12.9439C17.9284 2 22.0031 6.04074 22.0031 10.9794V22.952",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$d = /*#__PURE__*/forwardRef$1(SvgComponent$d, 'trim', false);

var SvgComponent$c = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.37036 33.1322V23.7822",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6296 23.7822V33.1322",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9327 10.6924H26.0674",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51514 18.0024H29.4848",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 10.6075L20.1111 3.3825C19.2323 2.8725 17.67 2.8725 16.7912 3.3825L4 10.6075",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0303 11.1177V23.0177",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0101 18.3423V23.0173",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8923 18.3423V23.0173",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.872 11.1177V23.0177",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.6074H7.22222C8.2963 10.6074 10.0539 10.6074 11.1279 10.6074H25.8721C26.9461 10.6074 28.7037 10.6074 29.7778 10.6074H33",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1684 10.6924H6.83167V23.8674H30.1684V10.6924Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9125 32.6227V27.0977H21.0876V32.6227",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$c = /*#__PURE__*/forwardRef$1(SvgComponent$c, 'tudor', true);

var SvgComponent$b = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.31836L3.45455 11.0002L6.31818 7.72745",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2273 17.5455C15.4819 17.5455 19 14.0273 19 9.77273C19 5.51818 15.4819 2 11.2273 2C6.97277 2 3.45459 5.51818 3.45459 9.77273V11",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$b = /*#__PURE__*/forwardRef$1(SvgComponent$b, 'undo', false);

var SvgComponent$a = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M9.28 6.487l3.094-3.094 3.094 3.094M15.468 18.861l-3.094 3.094-3.093-3.094M12.374 3.393v7.219M12.374 21.955v-7.219"
  }));
};
var ForwardRef$a = /*#__PURE__*/forwardRef$1(SvgComponent$a, 'up-down', false);

var SvgComponent$9 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.875C11.4142 16.1428 10.3125 15 10.3125 15C10.3125 15 11.1716 13.875 12 13.875C12.8284 13.875 13.6875 15 13.6875 15C13.6875 15 12.5858 16.1428 12 16.875ZM12 16.875C11.625 18.375 10.125 20.625 10.125 20.625L12 22.875L13.875 20.625C13.875 20.625 12.375 18.375 12 16.875Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H15.7499M4 21V19C4 17.9391 4.42143 16.9217 5.17157 16.1716C5.92172 15.4214 6.93913 15 8 15H8.24988",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$9 = /*#__PURE__*/forwardRef$1(SvgComponent$9, 'user-business', false);

var SvgComponent$8 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.9202 6.42188C15.6202 4.50961 13.9653 3.04688 11.9688 3.04688C9.97223 3.04688 8.31734 4.50961 8.01729 6.42188C7.98534 6.62552 7.96875 6.83426 7.96875 7.04688C7.96875 9.25601 9.75961 11.0469 11.9688 11.0469C13.3488 11.0469 14.5656 10.348 15.2846 9.28485M15.9202 6.42188H18.4688M15.9202 6.42188H10.4812",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0625 20.927V18.9357C20.0625 17.8794 19.6353 16.8665 18.8749 16.1196C18.1145 15.3727 17.0832 14.9531 16.0078 14.9531H15.6249H8.53448H7.89844C6.82307 14.9531 5.79174 15.3727 5.03134 16.1196C4.27094 16.8665 3.84375 17.8794 3.84375 18.9357V20.927M8.53448 18.375V20.927M8.53448 18.375V17.1141M8.53448 18.375H15.6249M15.6249 18.375V20.9271M15.6249 18.375V17.1141",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$8 = /*#__PURE__*/forwardRef$1(SvgComponent$8, 'user-construction', false);

var SvgComponent$7 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 13,
    height: 13,
    rx: 3,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5V5C16 3.89543 15.1046 3 14 3H6C4.34315 3 3 4.34315 3 6V13.5C3 14.8807 4.11929 16 5.5 16V16",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeDasharray: "0.5 4"
  }));
};
var ForwardRef$7 = /*#__PURE__*/forwardRef$1(SvgComponent$7, 'versions', false);

var SvgComponent$6 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.7931 12.4287V18.8766C18.7931 20.0201 17.7464 20.9618 16.4754 20.9618L8.61421 21.0002C7.34318 21.0002 6.29645 20.0585 6.29645 18.915V12.4671",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9.30121L10.7824 2.70553C11.7543 1.76482 13.3458 1.76482 14.3071 2.70553L21.0895 9.30121",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 3"
  }));
};
var ForwardRef$6 = /*#__PURE__*/forwardRef$1(SvgComponent$6, 'walls', false);

var SvgComponent$5 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "exclamation-triangle",
    className: "svg-inline--fa fa-exclamation-triangle fa-w-18",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
  }));
};
var ForwardRef$5 = /*#__PURE__*/forwardRef$1(SvgComponent$5, 'warning', false);

var SvgComponent$4 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39014 26.5V0.859863H31.6271V26.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1402 29H2.85974V33.4019H33.1402V29Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6846 16.3008H7.21008V25.2422H16.6846V16.3008Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6846 4.22998H7.21008V13.1714H16.6846V4.22998Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7899 16.3008H19.3326V25.2422H28.7899V16.3008Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7899 4.22998H19.3326V13.1714H28.7899V4.22998Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 38,
    fill: "white",
    transform: "translate(2)"
  }))));
};
var ForwardRef$4 = /*#__PURE__*/forwardRef$1(SvgComponent$4, 'window-grid', true);

var SvgComponent$3 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50006 5.5V30.5H30.5001V5.5H5.50006ZM16.8443 27.2159H8.57415V19.411H16.8443V27.2159ZM16.8443 16.7094H8.57415V8.87446H16.8443V16.7094ZM27.3509 27.2159H19.5001V19.411H27.4109L27.3509 27.2159ZM27.3509 16.7094H19.5001V8.87446H27.4109L27.3509 16.7094Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2495 2.75049H2.75049V33.2495H33.2495V2.75049Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(2 2)"
  }))));
};
var ForwardRef$3 = /*#__PURE__*/forwardRef$1(SvgComponent$3, 'window-trim', true);

var SvgComponent$2 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 18.3661C19 19.2601 18.3538 20 17.5731 20H6.42692C5.64615 20 5 19.2601 5 18.3661V5.63391C5 4.73989 5.64615 4 6.42692 4H17.5731C18.3538 4 19 4.73989 19 5.63391V18.3661Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4L12 20",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12L19 12",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var ForwardRef$2 = /*#__PURE__*/forwardRef$1(SvgComponent$2, 'window', false);

var SvgComponent$1 = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "with-accent",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39014 28.5V2.85986H31.6271V28.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1402 31H2.85974V35.4019H33.1402V31Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6846 18.3008H7.21008V27.2422H16.6846V18.3008Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6846 6.22998H7.21008V15.1714H16.6846V6.22998Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7899 18.3008H19.3326V27.2422H28.7899V18.3008Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7899 6.22998H19.3326V15.1714H28.7899V6.22998Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "stroke-accent"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 38,
    fill: "white",
    transform: "translate(2 2)"
  }))));
};
var ForwardRef$1 = /*#__PURE__*/forwardRef$1(SvgComponent$1, 'windows', true);

/**
 * Modified version of Feather's `loader` with the lines arranged
 * in clockwise order, starting at 12:00, and half of the lines
 * were flipped so that they are drawn from the center outward.
 *
 * Original order:
 * 🕛 1 ← 1
 * 🕑 2 ← 8
 * 🕒 3 ← 6
 * 🕔 4 ← 4
 * 🕕 5 ← 2
 * 🕗 6 ← 7
 * 🕘 7 ← 5
 * 🕙 8 ← 3
 *
 * Flipped lines:
 * 🕑 2 (8)
 * 🕒 3 (6)
 * 🕔 4 (4)
 * 🕕 5 (2)
 *
 * @see https://feathericons.com/?query=loader
 */
var SvgComponent = function SvgComponent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "feather feather-loader",
    fill: "none",
    height: 24,
    ref: ref,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("line", {
    id: "1",
    x1: 12,
    x2: 12,
    y1: 2,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    id: "2",
    x1: 19.07,
    x2: 16.24,
    y1: 4.93,
    y2: 7.76
  }), /*#__PURE__*/React.createElement("line", {
    id: "3",
    x1: 22,
    x2: 18,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "4",
    x1: 19.07,
    x2: 16.24,
    y1: 19.07,
    y2: 16.24
  }), /*#__PURE__*/React.createElement("line", {
    id: "5",
    x1: 12,
    x2: 12,
    y1: 22,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    id: "6",
    x1: 4.93,
    x2: 7.76,
    y1: 19.07,
    y2: 16.24
  }), /*#__PURE__*/React.createElement("line", {
    id: "7",
    x1: 2,
    x2: 6,
    y1: 12,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "8",
    x1: 4.93,
    x2: 7.76,
    y1: 4.93,
    y2: 7.76
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComponent, 'loader');

export { ForwardRef$V as hAccents, ForwardRef$U as hBack, ForwardRef$T as hBellyBand, ForwardRef$S as hBuilding, ForwardRef$R as hCalculator, ForwardRef$Q as hClipboardCheck, ForwardRef$P as hClipboardList, ForwardRef$O as hClose, ForwardRef$N as hCollapse, ForwardRef$M as hColumns, ForwardRef$L as hCornerPost, ForwardRef$K as hCrownMolding, ForwardRef$I as hDoors, ForwardRef$J as hDoorsTrim, ForwardRef$H as hDownspouts, ForwardRef$G as hEstimate, ForwardRef$F as hExpand, ForwardRef$E as hFascia, ForwardRef$D as hFriezeBoard, ForwardRef$C as hGarageDoorTrim, ForwardRef$B as hGarageDoors, ForwardRef$A as hGripVertical, ForwardRef$z as hGutters, ForwardRef$w as hHover, ForwardRef$y as hHoverRotate, ForwardRef$x as hHoverSolid, ForwardRef$v as hLoader, ForwardRef$u as hMeasure, ForwardRef$t as hPillisters, ForwardRef$s as hPresets, ForwardRef$r as hRakeBoard, ForwardRef$q as hRedo, ForwardRef$p as hReset, ForwardRef$o as hRoof, ForwardRef$n as hSearch, ForwardRef$m as hSelected, ForwardRef$l as hShare, ForwardRef$k as hShutters, ForwardRef$j as hSoffit, ForwardRef$h as hStorybook, ForwardRef$i as hStorybook2, ForwardRef$g as hThumbtack, ForwardRef$f as hThumbtacked, ForwardRef$e as hTriangleRuler, ForwardRef$d as hTrim, ForwardRef$c as hTudor, ForwardRef$b as hUndo, ForwardRef$a as hUpDown, ForwardRef$9 as hUserBusiness, ForwardRef$8 as hUserConstruction, ForwardRef$7 as hVersions, ForwardRef$6 as hWalls, ForwardRef$5 as hWarning, ForwardRef$2 as hWindow, ForwardRef$4 as hWindowGrid, ForwardRef$3 as hWindowTrim, ForwardRef$1 as hWindows, ForwardRef$5o as iActivity, ForwardRef$5n as iAirplay, ForwardRef$5m as iAlertCircle, ForwardRef$5l as iAlertOctagon, ForwardRef$5k as iAlertTriangle, ForwardRef$5j as iAlignCenter, ForwardRef$5i as iAlignJustify, ForwardRef$5h as iAlignLeft, ForwardRef$5g as iAlignRight, ForwardRef$5f as iAnchor, ForwardRef$5e as iAperture, ForwardRef$5d as iArchive, ForwardRef$59 as iArrowDown, ForwardRef$5c as iArrowDownCircle, ForwardRef$5b as iArrowDownLeft, ForwardRef$5a as iArrowDownRight, ForwardRef$57 as iArrowLeft, ForwardRef$58 as iArrowLeftCircle, ForwardRef$55 as iArrowRight, ForwardRef$56 as iArrowRightCircle, ForwardRef$51 as iArrowUp, ForwardRef$54 as iArrowUpCircle, ForwardRef$53 as iArrowUpLeft, ForwardRef$52 as iArrowUpRight, ForwardRef$50 as iAtSign, ForwardRef$4$ as iAward, ForwardRef$4Z as iBarChart, ForwardRef$4_ as iBarChart2, ForwardRef$4X as iBattery, ForwardRef$4Y as iBatteryCharging, ForwardRef$4V as iBell, ForwardRef$4W as iBellOff, ForwardRef$4U as iBluetooth, ForwardRef$4T as iBold, ForwardRef$4R as iBook, ForwardRef$4S as iBookOpen, ForwardRef$4Q as iBookmark, ForwardRef$4P as iBox, ForwardRef$4O as iBriefcase, ForwardRef$4N as iCalendar, ForwardRef$4L as iCamera, ForwardRef$4M as iCameraOff, ForwardRef$4K as iCast, ForwardRef$4H as iCheck, ForwardRef$4J as iCheckCircle, ForwardRef$4I as iCheckSquare, ForwardRef$4G as iChevronDown, ForwardRef$4F as iChevronLeft, ForwardRef$4E as iChevronRight, ForwardRef$4D as iChevronUp, ForwardRef$4C as iChevronsDown, ForwardRef$4B as iChevronsLeft, ForwardRef$4A as iChevronsRight, ForwardRef$4z as iChevronsUp, ForwardRef$4y as iChrome, ForwardRef$4x as iCircle, ForwardRef$4w as iClipboard, ForwardRef$4v as iClock, ForwardRef$4p as iCloud, ForwardRef$4u as iCloudDrizzle, ForwardRef$4t as iCloudLightning, ForwardRef$4s as iCloudOff, ForwardRef$4r as iCloudRain, ForwardRef$4q as iCloudSnow, ForwardRef$4o as iCode, ForwardRef$4n as iCodepen, ForwardRef$4m as iCodesandbox, ForwardRef$4l as iCoffee, ForwardRef$4k as iColumns, ForwardRef$4j as iCommand, ForwardRef$4i as iCompass, ForwardRef$4h as iCopy, ForwardRef$4g as iCornerDownLeft, ForwardRef$4f as iCornerDownRight, ForwardRef$4e as iCornerLeftDown, ForwardRef$4d as iCornerLeftUp, ForwardRef$4c as iCornerRightDown, ForwardRef$4b as iCornerRightUp, ForwardRef$4a as iCornerUpLeft, ForwardRef$49 as iCornerUpRight, ForwardRef$48 as iCpu, ForwardRef$47 as iCreditCard, ForwardRef$46 as iCrop, ForwardRef$45 as iCrosshair, ForwardRef$44 as iDatabase, ForwardRef$43 as iDelete, ForwardRef$42 as iDisc, ForwardRef$3$ as iDivide, ForwardRef$41 as iDivideCircle, ForwardRef$40 as iDivideSquare, ForwardRef$3_ as iDollarSign, ForwardRef$3Y as iDownload, ForwardRef$3Z as iDownloadCloud, ForwardRef$3X as iDribbble, ForwardRef$3W as iDroplet, ForwardRef$3T as iEdit, ForwardRef$3V as iEdit2, ForwardRef$3U as iEdit3, ForwardRef$3S as iExternalLink, ForwardRef$3Q as iEye, ForwardRef$3R as iEyeOff, ForwardRef$3P as iFacebook, ForwardRef$3O as iFastForward, ForwardRef$3N as iFeather, ForwardRef$3M as iFigma, ForwardRef$3I as iFile, ForwardRef$3L as iFileMinus, ForwardRef$3K as iFilePlus, ForwardRef$3J as iFileText, ForwardRef$3H as iFilm, ForwardRef$3G as iFilter, ForwardRef$3F as iFlag, ForwardRef$3C as iFolder, ForwardRef$3E as iFolderMinus, ForwardRef$3D as iFolderPlus, ForwardRef$3B as iFramer, ForwardRef$3A as iFrown, ForwardRef$3z as iGift, ForwardRef$3y as iGitBranch, ForwardRef$3x as iGitCommit, ForwardRef$3w as iGitMerge, ForwardRef$3v as iGitPullRequest, ForwardRef$3u as iGithub, ForwardRef$3t as iGitlab, ForwardRef$3s as iGlobe, ForwardRef$3r as iGrid, ForwardRef$3q as iHardDrive, ForwardRef$3p as iHash, ForwardRef$3o as iHeadphones, ForwardRef$3n as iHeart, ForwardRef$3m as iHelpCircle, ForwardRef$3l as iHexagon, ForwardRef$3k as iHome, ForwardRef$3j as iImage, ForwardRef$3i as iInbox, ForwardRef$3h as iInfo, ForwardRef$3g as iInstagram, ForwardRef$3f as iItalic, ForwardRef$3e as iKey, ForwardRef$3d as iLayers, ForwardRef$3c as iLayout, ForwardRef$3b as iLifeBuoy, ForwardRef$39 as iLink, ForwardRef$3a as iLink2, ForwardRef$38 as iLinkedin, ForwardRef$37 as iList, ForwardRef$36 as iLoader, ForwardRef as iLoaderClockwise, ForwardRef$35 as iLock, ForwardRef$34 as iLogIn, ForwardRef$33 as iLogOut, ForwardRef$32 as iMail, ForwardRef$30 as iMap, ForwardRef$31 as iMapPin, ForwardRef$2_ as iMaximize, ForwardRef$2$ as iMaximize2, ForwardRef$2Z as iMeh, ForwardRef$2Y as iMenu, ForwardRef$2X as iMessageCircle, ForwardRef$2W as iMessageSquare, ForwardRef$2U as iMic, ForwardRef$2V as iMicOff, ForwardRef$2S as iMinimize, ForwardRef$2T as iMinimize2, ForwardRef$2P as iMinus, ForwardRef$2R as iMinusCircle, ForwardRef$2Q as iMinusSquare, ForwardRef$2O as iMonitor, ForwardRef$2N as iMoon, ForwardRef$2M as iMoreHorizontal, ForwardRef$2L as iMoreVertical, ForwardRef$2K as iMousePointer, ForwardRef$2J as iMove, ForwardRef$2I as iMusic, ForwardRef$2G as iNavigation, ForwardRef$2H as iNavigation2, ForwardRef$2F as iOctagon, ForwardRef$2E as iPackage, ForwardRef$2D as iPaperclip, ForwardRef$2B as iPause, ForwardRef$2C as iPauseCircle, ForwardRef$2A as iPenTool, ForwardRef$2z as iPercent, ForwardRef$2s as iPhone, ForwardRef$2y as iPhoneCall, ForwardRef$2x as iPhoneForwarded, ForwardRef$2w as iPhoneIncoming, ForwardRef$2v as iPhoneMissed, ForwardRef$2u as iPhoneOff, ForwardRef$2t as iPhoneOutgoing, ForwardRef$2r as iPieChart, ForwardRef$2p as iPlay, ForwardRef$2q as iPlayCircle, ForwardRef$2m as iPlus, ForwardRef$2o as iPlusCircle, ForwardRef$2n as iPlusSquare, ForwardRef$2l as iPocket, ForwardRef$2k as iPower, ForwardRef$2j as iPrinter, ForwardRef$2i as iRadio, ForwardRef$2h as iRefreshCcw, ForwardRef$2g as iRefreshCw, ForwardRef$2f as iRepeat, ForwardRef$2e as iRewind, ForwardRef$2d as iRotateCcw, ForwardRef$2c as iRotateCw, ForwardRef$2b as iRss, ForwardRef$2a as iSave, ForwardRef$29 as iScissors, ForwardRef$28 as iSearch, ForwardRef$27 as iSend, ForwardRef$26 as iServer, ForwardRef$25 as iSettings, ForwardRef$23 as iShare, ForwardRef$24 as iShare2, ForwardRef$21 as iShield, ForwardRef$22 as iShieldOff, ForwardRef$20 as iShoppingBag, ForwardRef$1$ as iShoppingCart, ForwardRef$1_ as iShuffle, ForwardRef$1Z as iSidebar, ForwardRef$1Y as iSkipBack, ForwardRef$1X as iSkipForward, ForwardRef$1W as iSlack, ForwardRef$1V as iSlash, ForwardRef$1U as iSliders, ForwardRef$1T as iSmartphone, ForwardRef$1S as iSmile, ForwardRef$1R as iSpeaker, ForwardRef$1Q as iSquare, ForwardRef$1P as iStar, ForwardRef$1O as iStopCircle, ForwardRef$1N as iSun, ForwardRef$1M as iSunrise, ForwardRef$1L as iSunset, ForwardRef$1K as iTable, ForwardRef$1J as iTablet, ForwardRef$1I as iTag, ForwardRef$1H as iTarget, ForwardRef$1G as iTerminal, ForwardRef$1F as iThermometer, ForwardRef$1E as iThumbsDown, ForwardRef$1D as iThumbsUp, ForwardRef$1C as iToggleLeft, ForwardRef$1B as iToggleRight, ForwardRef$1A as iTool, ForwardRef$1y as iTrash, ForwardRef$1z as iTrash2, ForwardRef$1x as iTrello, ForwardRef$1w as iTrendingDown, ForwardRef$1v as iTrendingUp, ForwardRef$1u as iTriangle, ForwardRef$1t as iTruck, ForwardRef$1s as iTv, ForwardRef$1r as iTwitch, ForwardRef$1q as iTwitter, ForwardRef$1p as iType, ForwardRef$1o as iUmbrella, ForwardRef$1n as iUnderline, ForwardRef$1m as iUnlock, ForwardRef$1k as iUpload, ForwardRef$1l as iUploadCloud, ForwardRef$1f as iUser, ForwardRef$1j as iUserCheck, ForwardRef$1i as iUserMinus, ForwardRef$1h as iUserPlus, ForwardRef$1g as iUserX, ForwardRef$1e as iUsers, ForwardRef$1c as iVideo, ForwardRef$1d as iVideoOff, ForwardRef$1b as iVoicemail, ForwardRef$17 as iVolume, ForwardRef$1a as iVolume1, ForwardRef$19 as iVolume2, ForwardRef$18 as iVolumeX, ForwardRef$16 as iWatch, ForwardRef$14 as iWifi, ForwardRef$15 as iWifiOff, ForwardRef$13 as iWind, ForwardRef$$ as iX, ForwardRef$12 as iXCircle, ForwardRef$11 as iXOctagon, ForwardRef$10 as iXSquare, ForwardRef$_ as iYoutube, ForwardRef$Y as iZap, ForwardRef$Z as iZapOff, ForwardRef$X as iZoomIn, ForwardRef$W as iZoomOut };
